export default  {
    "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
    "title": "Get Ready Pack: Milano Cortina 2026",
    "shortTitle": "",
    "description": "",
    "width": 620,
    "height": 877,
    "currentLanguage": "EN",
    "languages": [
      {
        code: "EN",
        text: "English",
        href: "https://getreadypack.olympics.com/milanocortina2026/en/"
      },
      {
        code: "FR",
        text: "Français",
        href: "https://getreadypack.olympics.com/milanocortina2026/fr/"
      },
      {
        code: "ES",
        text: "Español",
        href: "https://getreadypack.olympics.com/milanocortina2026/es/"
      },
      {
        code: "IT",
        text: "Italiano",
        href: "https://getreadypack.olympics.com/milanocortina2026/it/"
      },
      {
        code: "CN",
        text: "Chinese",
        href: "https://getreadypack.olympics.com/milanocortina2026/cn/"
      },
      {
        code: "RU",
        text: "Russian",
        href: "https://getreadypack.olympics.com/milanocortina2026/ru/"
      }
    ],
    "basePath": "/milanocortina2026/en",
    // "basePath": "",
    "companyLogo": "1-logo-1.png",
    "publishURL": "https://getreadypack.olympics.com/static/_thumbs/",
    "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
    "options": {
      "doublePage": true,
      "rightToLeft": false,
      "searchEnabled": true,
      "downloadEnabled": true,
      "downloadPath": '/milanocortina2026/en/static/_content/Athlete365_GetReadyPack_MilanoCortina_v2.pdf',
      "printEnabled": false,
      "zoom": {
        "navEnabled": false,
        "sliderEnabled": true,
        "clickEnabled": true,
        "scrollEnabled": true,
      },
      "contents": {
        "enabled": true,
        "pinned": false,
        "numbers": true,
        "titles": true,
      },
      "languagesEnabled": true,
      "editionsEnabled": false,
      "mobileSwitch": false,
      "guideEnabled": false,
      "galleryCaptions": {},
      "fullscreenEnabled": true,
    },
    "pages": [[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 0,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg1.jpg",
      "zoom": null,
      "content": `
      
      <img class="abs halfScaleC 1-logo" style="top:17px;left:-53px;" src="/milanocortina2026/en/static/_content/1-logo-1.png"/>
      <img class="abs halfScaleC 1-title" style="top:-26px;left:-203px;" src="/milanocortina2026/en/static/_content/1-title-1.png"/>
      <img class="abs halfScaleC 1-sub" style="top:461px;left:-134px;" src="/milanocortina2026/en/static/_content/1-sub-1.png"/>
      <img class="abs halfScaleC" style="top:46px;left:233px;" src="/milanocortina2026/en/static/_content/1-image-1.png"/>

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
      
      <a href="https://www.olympics.com/athlete365" target="_blank" class="pointer">
        <img class="abs halfScaleC 1-logo" style="top:17px;left:-53px;" src="/milanocortina2026/en/static/_content/1-logo-1.png"/>
      </a>
      <img class="abs halfScaleC 1-title" style="top:-26px;left:-203px;" src="/milanocortina2026/en/static/_content/1-title-1.png"/>
      <img class="abs halfScaleC 1-sub" style="top:461px;left:-134px;" src="/milanocortina2026/en/static/_content/1-sub-1.png"/>
      <img class="abs halfScaleC" style="top:46px;left:233px;" src="/milanocortina2026/en/static/_content/1-image-1.png"/>

      <img class="abs halfScaleC halfpulse animatedpulse 3-btn pointer" onclick="Publish.goToPage(2);" style="top:695px;left:444px;" src="/milanocortina2026/en/static/_content/1-arrow-1.png"/>

      `,
      "script": `
        function onPageEnter() {
          pg1Anim = new TimelineMax();
          pg1Anim.fromTo(cOf("1-logo"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1)
          .fromTo(cOf("1-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.2)
          .fromTo(cOf("1-sub"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.4)
        }

        function onPageLeave() {
          pg1Anim.stop();
        }
      `,
      "searchText": "get ready PACK MILANO CORTINA 2026"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 1,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg2.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>

      <img class="abs halfScale 2-title" style="top:94px;left:41px;" src="/milanocortina2026/en/static/_content/2-title-1.png"/>

      <div class="addContentLink" onclick="Publish.goToPage(3);" style="top:188px; left:68px; width:208px; height:12px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(4);" style="top:201px; left:68px; width:208px; height:12px;"></div>

      <div class="addContentLink" onclick="Publish.goToPage(5);" style="top:232px; left:62px; width:128px; height:18px;"></div>

      <div class="addContentLink" onclick="Publish.goToPage(6);" style="top:250px; left:68px; width:208px; height:12px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(7);" style="top:263px; left:68px; width:208px; height:12px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(8);" style="top:277px; left:68px; width:208px; height:12px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(9);" style="top:290px; left:68px; width:208px; height:12px;"></div>

      <div class="addContentLink" onclick="Publish.goToPage(10);" style="top:322px; left:63px; width:150px; height:18px;"></div>
      
      <div class="addContentLink" onclick="Publish.goToPage(11);" style="top:340px; left:68px; width:208px; height:12px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(12);" style="top:353px; left:68px; width:208px; height:12px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(13);" style="top:367px; left:68px; width:208px; height:12px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(14);" style="top:380px; left:68px; width:208px; height:12px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(15);" style="top:394px; left:68px; width:208px; height:12px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(16);" style="top:407px; left:68px; width:208px; height:12px;"></div>

      <div class="addContentLink" onclick="Publish.goToPage(17);" style="top:439px; left:62px; width:108px; height:18px;"></div>

      <div class="addContentLink" onclick="Publish.goToPage(18);" style="top:458px; left:68px; width:208px; height:12px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(19);" style="top:471px; left:68px; width:208px; height:12px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(20);" style="top:485px; left:68px; width:208px; height:12px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(22);" style="top:498px; left:68px; width:208px; height:12px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(23);" style="top:513px; left:68px; width:208px; height:12px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(24);" style="top:526px; left:68px; width:208px; height:12px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(25);" style="top:540px; left:68px; width:208px; height:12px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(26);" style="top:554px; left:68px; width:208px; height:12px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(27);" style="top:568px; left:68px; width:208px; height:12px;"></div>

      <div class="addContentLink" onclick="Publish.goToPage(28);" style="top:186px; left:332px; width:210px; height:18px;"></div>

      <div class="addContentLink" onclick="Publish.goToPage(29);" style="top:205px; left:337px; width:228px; height:12px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(30);" style="top:219px; left:337px; width:228px; height:12px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(31);" style="top:233px; left:337px; width:228px; height:12px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(32);" style="top:247px; left:337px; width:228px; height:12px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(33);" style="top:261px; left:337px; width:228px; height:12px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(34);" style="top:274px; left:337px; width:228px; height:12px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(35);" style="top:288px; left:337px; width:228px; height:12px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(36);" style="top:302px; left:337px; width:228px; height:12px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(37);" style="top:316px; left:337px; width:228px; height:12px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(38);" style="top:330px; left:337px; width:228px; height:12px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(39);" style="top:342px; left:337px; width:228px; height:12px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(40);" style="top:356px; left:337px; width:228px; height:12px;"></div>

      <div class="addContentLink" onclick="Publish.goToPage(41);" style="top:385px; left:332px; width:86px; height:18px;"></div>

      <div class="addContentLink" onclick="Publish.goToPage(42);" style="top:405px; left:337px; width:228px; height:12px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(43);" style="top:418px; left:337px; width:228px; height:12px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(44);" style="top:432px; left:337px; width:228px; height:12px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(45);" style="top:446px; left:337px; width:228px; height:12px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(46);" style="top:459px; left:337px; width:228px; height:12px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(47);" style="top:473px; left:337px; width:228px; height:12px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(48);" style="top:487px; left:337px; width:228px; height:12px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(49);" style="top:502px; left:337px; width:228px; height:12px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(50);" style="top:514px; left:337px; width:228px; height:12px;"></div>

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
      `,
      "script": `
        function onPageEnter() {
          pg2Anim = new TimelineMax();
          pg2Anim.fromTo(cOf("2-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1)
        }

        function onPageLeave() {
          pg2Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "Get Ready Pack: Milano Cortina 2026 | Contents  Contents  2  contents 3 Join the community 4 Welcome to Milano Cortina 2026  Getting to the games 6 7 8 9  Arrivals Accreditation Transport Olympic Villages map  Welcome to your Village 11 Milan 12 Cortina 13 Predazzo 14 Livigno 15 Bormio 16 Anterselva  Life in the Village  18 Olympic Village services 19 Athlete365 House 20 IOC Athletes' Commission election 22 Athlete365 x Powerade Mind Zone 23 Believe in Sport ambassadors 24 Pamper yourself with P&G 25 Paying with Visa 26 Your Golden Moment 27 Eating and drinking  Maximising your Games experience 29 Airbnb500 30 Olympic Edition Samsung phone 31 Athlete Moment 32 Capture your Olympic experience 33 Social media verification 34 Online abuse protection 35 Athlete365 app 36 Athlete365 Learning 37 PinQuest 38 How to access tickets 39 Opening Ceremony 40 Get Set – Train Smarter  Need to know  42 Getting to your competition venue 43 How to seek help 44 Social media guidelines 45 Athlete Expression 46 Commercial opportunities 47 Prevention of competition manipulation 48 Anti-doping 49 Sustainability 50 Departures"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 2,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg3.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
      
      <img class="abs halfScale 3-title" style="top:70px;left:41px;" src="/milanocortina2026/en/static/_content/3-title-1.png"/>
      <img class="abs halfScale 3-sub" style="top:159px;left:40px;" src="/milanocortina2026/en/static/_content/3-sub-1.png"/>

      <img class="abs halfScale 3-box" style="top:513px;left:-37px;" src="/milanocortina2026/en/static/_content/3-box-1.png"/>
      <img class="abs halfScale 3-box" style="top:605px;left:-23px;" src="/milanocortina2026/en/static/_content/3-box-2.png"/>
      <img class="abs halfScale 3-box" style="top:698px;left:-31px;" src="/milanocortina2026/en/static/_content/3-box-3.png"/>

      <a href="https://www.olympics.com/athlete365/auth/sign-in" target="_blank">
        <img class="abs halfScaleC halfpulse animatedpulse 3-btn" style="top:770px;left:-35px;" src="/milanocortina2026/en/static/_content/3-btn-1.png"/>
      </a>

      `,
      "script": `
        function onPageEnter() {
          pg3Anim = new TimelineMax();
          pg3Anim.fromTo(cOf("3-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("3-sub"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.2)
          .staggerFromTo(cOf("3-box"), 0.7, {opacity:0, x: -513}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 0.1, 1.4)
        }

        function onPageLeave() {
          pg3Anim.stop();
        }
      `,
      "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Join the community  Join the community We’re on a mission to make athletes’ lives better.  Athlete365 is the global community for Olympians, Paralympians, elite-level athletes and their entourage members. We have more than 200,000 members from around the world, and we’d love you to join us. Here’s why you should sign up today.  Access our exclusive offers  Including the Airbnb500 Travel Grant.  Level up with Athlete365 Learning and Career+ Empower yourself on and off the field of play.  Personalise your Athlete365 experience  Get the content that matters most to you.  SIGN UP NOW  3"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 3,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg4.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
      
      <img class="abs halfScale 4-title" style="top:66px;left:20px;" src="/milanocortina2026/en/static/_content/4-title-1.png" />
      <img class="abs halfScale 4-title" style="top:139px;left:23px;" src="/milanocortina2026/en/static/_content/4-title-2.png" />
      <img class="abs halfScale 4-sub" style="top:230px;left:21px;" src="/milanocortina2026/en/static/_content/4-sub-1.png" />

      <img class="abs halfScaleC 4-icon-lg" style="top:265px;left:-18px;" src="/milanocortina2026/en/static/_content/4-icon-lg-1.png" />
      <img class="abs halfScaleC 4-icon-lg" style="top:265px;left:295px;" src="/milanocortina2026/en/static/_content/4-icon-lg-2.png" />

      <h1 id="4-no" class="abs olympicHeadlineReg 4-no" style="top:290px;left:109px; font-size: 3.3em; font-weight: 300; color: #ffb114; padding: 0px; margin: 0px;"  data-number='{"to": 13}' ></h1>
      <img class="abs halfScaleC 4-text" style="top:327px;left:45px;" src="/milanocortina2026/en/static/_content/4-text-1.png" />

      <h1 id="4-no" class="abs olympicHeadlineReg 4-no" style="top:290px;left:422px; font-size: 3.3em; font-weight: 300; color: #ffb114; padding: 0px; margin: 0px;"  data-number='{"to": 16}' ></h1>
      <img class="abs halfScaleC 4-text" style="top:326px;left:367px;" src="/milanocortina2026/en/static/_content/4-text-2.png" />

      <img class="abs halfScale 4-line-lg" style="top:402px;left:17px;" src="/milanocortina2026/en/static/_content/4-line-lg.png" />

      <h1 id="4-no" class="abs olympicHeadlineReg 4-no" style="top:412px;left:20px; font-size: 1.4em; font-weight: 300; color: #ffb114; padding: 0px; margin: 0px;"  data-number='{"to": 116}' ></h1>
      <img class="abs halfScale 4-text-left" style="top:421px;left:23px;" src="/milanocortina2026/en/static/_content/4-text-3.png" />

      <img class="abs halfScaleC 4-icon" style="top:439px;left:6px;" src="/milanocortina2026/en/static/_content/4-icon-1.png" />
      <img class="abs halfScaleC 4-icon" style="top:485px;left:6px;" src="/milanocortina2026/en/static/_content/4-icon-2.png" />
      <img class="abs halfScaleC 4-icon" style="top:521px;left:6px;" src="/milanocortina2026/en/static/_content/4-icon-3.png" />
      <img class="abs halfScaleC 4-icon" style="top:439px;left:160px;" src="/milanocortina2026/en/static/_content/4-icon-4.png" />
      <img class="abs halfScaleC 4-icon" style="top:475px;left:160px;" src="/milanocortina2026/en/static/_content/4-icon-5.png" />
      <img class="abs halfScaleC 4-icon" style="top:511px;left:160px;" src="/milanocortina2026/en/static/_content/4-icon-6.png" />

      <img class="abs halfScale 4-text-left" style="top:455px;left:49px;" src="/milanocortina2026/en/static/_content/4-text-4.png" />
      <img class="abs halfScale 4-text-left" style="top:502px;left:49px;" src="/milanocortina2026/en/static/_content/4-text-5.png" />
      <img class="abs halfScale 4-text-left" style="top:538px;left:49px;" src="/milanocortina2026/en/static/_content/4-text-6.png" />
      <img class="abs halfScale 4-text-left" style="top:456px;left:204px;" src="/milanocortina2026/en/static/_content/4-text-7.png" />
      <img class="abs halfScale 4-text-left" style="top:492px;left:205px;" src="/milanocortina2026/en/static/_content/4-text-8.png" />
      <img class="abs halfScale 4-text-left" style="top:528px;left:205px;" src="/milanocortina2026/en/static/_content/4-text-9.png" />

      <img class="abs halfScale 4-line-sm" style="top:417px;left:324px;" src="/milanocortina2026/en/static/_content/4-line-sm.png" />

      <img class="abs halfScale 4-bar-1" style="top:466px;left:351px;" src="/milanocortina2026/en/static/_content/4-bar-1.png" />
      <img class="abs halfScale 4-bar-2" style="top:466px;left:468px;" src="/milanocortina2026/en/static/_content/4-bar-2.png" />
      <img class="abs halfScaleC 4-line-dot" style="top:385px;left:293px;" src="/milanocortina2026/en/static/_content/4-line-dot.png" />
      <h1 id="4-no" class="abs olympicHeadlineReg 4-no" style="top:412px;left:365px; font-size: 1.4em; font-weight: 300; color: #ffb114; padding: 0px; margin: 0px;"  data-number='{"to": 47, "append": "%"}' ></h1>
      <img class="abs halfScale 4-text-right" style="top:437px;left:366px;" src="/milanocortina2026/en/static/_content/4-text-10.png" />
      <img class="abs halfScale 4-text-right" style="top:510px;left:352px;" src="/milanocortina2026/en/static/_content/4-text-11.png" />

    `,
      "script": `
        function onPageEnter() {
          pg4Anim = new TimelineMax();
          pg4Anim.staggerFromTo(cOf("4-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .fromTo(cOf("4-sub"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.4)
          .staggerFromTo(cOf("4-icon-lg"), 0.8, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.4, 1.6)
          .fromTo(cOf("4-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("4-no")[0])}}, 1.8)
          .staggerFromTo(cOf("4-text"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1.9)
          .fromTo(cOf("4-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("4-no")[1])}}, 1.9)
          .fromTo(cOf("4-line-lg"), 0.8, {opacity:0, y: 20}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2)
          .fromTo(cOf("4-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("4-no")[2])}}, 2.1)
          .staggerFromTo(cOf("4-text-left"), 0.3, {opacity:0, x: 20}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 2.2)
          .staggerFromTo(cOf("4-icon"), 0.3, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 2.3)
          .fromTo(cOf("4-line-sm"), 0.8, {opacity:0, y: 20}, {opacity: 1, y: 0, ease: Power2.easeOut}, 2.35)
          .fromTo(cOf("4-bar-1"), 0.7, {opacity:0, x: -40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.4)
          .fromTo(cOf("4-bar-2"), 0.7, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 2.4)
          .fromTo(cOf("4-line-dot"), 0.8, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 2.45)
          .fromTo(cOf("4-no")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("4-no")[3])}}, 2.5)
          .staggerFromTo(cOf("4-text-right"), 0.3, {opacity:0, y: 20}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, 2.6)
        }

        function onPageLeave() {
          pg4Anim.stop();
          resetNumbers("4-no");
        }
      `,
      "searchText": "Get Ready Pack: Milano Cortina 2026 | Welcome to Milano Cortina 2026  Contents  4  Welcome to Milano Cortina 2026 Blending decades of winter sports expertise, legendary venues and a passionate local fan base, Milano Cortina 2026 will be truly unique.  13  16  competition venues  disciplines  With breathtaking backdrops across northern Italy  Featuring an Olympic debut for ski mountaineering  47%  116 medal events  Including new medal events in:  Alpine skiing  men’s and women’s team combined  Freestyle skiing  men’s and women’s dual moguls  Luge  women’s doubles  female athletes Skeleton  mixed team  Ski jumping  women’s large hill  Ski mountaineering  men’s and women’s sprint, mixed relay  Making this the most gender-balanced Olympic Winter Games in history"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 4,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg5.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>

      <img class="abs halfScale 5-title" style="top:106px;left:200px;" src="/milanocortina2026/en/static/_content/5-title-1.png"/>
      <img class="abs halfScale 5-title" style="top:177px;left:200px;" src="/milanocortina2026/en/static/_content/5-title-2.png"/>
      <img class="abs halfScale 5-title" style="top:580px;left:90px;" src="/milanocortina2026/en/static/_content/5-sub-1.png"/>

      <div class="addContentLink" onclick="Publish.goToPage(6);" style="top:633px; left:238px; width:156px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(7);" style="top:671px; left:238px; width:156px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(8);" style="top:709px; left:238px; width:156px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(9);" style="top:747px; left:238px; width:156px; height:22px;"></div>

      `,
      "script": `
        function onPageEnter() {
          pg5Anim = new TimelineMax();
          pg5Anim.staggerFromTo(cOf("5-title"), 0.8, {opacity:0, x: -40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);
          setTimeout(function(){
            addContentLinks();
          },2000)
        }

        function onPageLeave() {
          pg5Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "Get Ready Pack: Milano Cortina 2026 | Getting to the Games  Contents  GETTING TO the GAMES  Your journey at Milano Cortina 2026 starts here. 6 Arrivals 7 Accreditation 8 Transport 9 Olympic Villages map  Getting to the games  5"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 5,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg6.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
      
      <img class="abs halfScale 6-title" style="top:85px;left:21px;" src="/milanocortina2026/en/static/_content/6-title-1.png"/>
      <img class="abs halfScale 6-sub" style="top:149px;left:20px;" src="/milanocortina2026/en/static/_content/6-sub-1.png"/>

      <a href="https://athlete365.org/arrivals-mico-2026" target="_blank">
        <img class="abs halfScaleC halfpulse animatedpulse 6-btn" style="top:746px;left:274px;" src="/milanocortina2026/en/static/_content/6-btn-1.png"/>
      </a>

    `,
      "script": `
        function onPageEnter() {
          pg6Anim = new TimelineMax();
          pg6Anim.fromTo(cOf("6-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("6-sub"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.2)
        }

        function onPageLeave() {
          pg6Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Arrivals  6  Arrivals What to expect when you arrive in Italy. Due to the widespread nature of Milano Cortina 2026, the arrivals system is split into two zones.  West Zone Villages: Milan, Livigno and Bormio Main point of entry: Milano Malpensa Airport Other entry points:  • Milano Centrale train station and Milano Linate Airport (for Milan) • Tirano train station (for Livigno and Bormio)  Journey times from Milano Malpensa Airport: Milan Village: 1 h 30 mins Bormio Village: 4 h 30 mins Livigno Village: 6 h 45 mins  East Zone Villages: Cortina, Predazzo, Anterselva Main point of entry: Venezia Marco Polo Airport Other entry points:  • Venezia Mestre train station (for Cortina or Anterselva) • Trento train station (for Predazzo) • Valdaora train station (for Anterselva)  Journey times from Venezia Marco Polo Airport: Cortina Village: 3 h 15 mins Predazzo Village: 3 h 50 mins Anterselva Village: 4 h 35 mins  Getting to the games  FIND OUT MORE If you have any questions about your arrival procedure, speak to your NOC, e.g. your Chef de Mission."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 6,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg7.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
      
      <img class="abs halfScale 7-title" style="top:85px;left:21px;" src="/milanocortina2026/en/static/_content/7-title-1.png"/>
      <img class="abs halfScale 7-sub" style="top:149px;left:20px;" src="/milanocortina2026/en/static/_content/7-sub-1.png"/>

      <img class="abs halfScale 7-box" style="top:462px;left:18px;" src="/milanocortina2026/en/static/_content/7-box-1.png"/>
      <img class="abs halfScale 7-box" style="top:462px;left:211px;" src="/milanocortina2026/en/static/_content/7-box-2.png"/>
      <img class="abs halfScale 7-box" style="top:462px;left:406px;" src="/milanocortina2026/en/static/_content/7-box-3.png"/>

      <img class="abs halfScale 7-box-4" style="top:741px;left:261px;" src="/milanocortina2026/en/static/_content/7-box-4.png"/>

      <img class="abs halfScale 7-box-5" style="top:833px;left:-35px;" src="/milanocortina2026/en/static/_content/7-bottom-bar.png"/>

    `,
      "script": `
        function onPageEnter() {
          pg7Anim = new TimelineMax();
          pg7Anim.fromTo(cOf("7-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("7-sub"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.2)
          .staggerFromTo(cOf("7-box"), 0.7, {opacity:0, y: 400}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 0.1, 1.4)
          .fromTo(cOf("7-box-4"), 0.7, {opacity:0, x: 400}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 2)
        }

        function onPageLeave() {
          pg7Anim.stop();
        }
      `,
      "searchText": "Get Ready Pack: Milano Cortina 2026 | Accreditation  Contents  7  Accreditation How to validate your accreditation and keep it safe.  1  Before travelling to the Games, you will be issued with a Pre-Valid Card (PVC). If you require a visa, this will be printed on your PVC, which must be presented at immigration with a valid travel document.  2  Your PVC must then be validated when you arrive at the Games. You will then be issued with an Olympic Identity and Accreditation Card (OIAC).  3  Your OIAC is your official accreditation, granting you access to the venues and services you need. You must carry it with you at all times, apart from training or competition.  TIP: Hang your accreditation on the inside door handle of your room before you go to bed. Then, when you leave your room, you’ll be reminded to put it on. For more information, please contact your NOC.  Getting to the games"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 7,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg8.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
      
      <img class="abs halfScale 8-title" style="top:85px;left:80px;" src="/milanocortina2026/en/static/_content/8-title-1.png"/>
      <img class="abs halfScale 8-title" style="top:148px;left:193px;" src="/milanocortina2026/en/static/_content/8-sub-1.png"/>
      <img class="abs halfScale 8-title" style="top:185px;left:198px;" src="/milanocortina2026/en/static/_content/8-text-1.png"/>
      <img class="abs halfScale 8-title" style="top:220px;left:109px;" src="/milanocortina2026/en/static/_content/8-line-1.png"/>

      <img class="abs halfScaleC 8-box" style="top:138px;left:-70px;" src="/milanocortina2026/en/static/_content/8-box-1.png" />
      <img class="abs halfScaleC 8-box" style="top:138px;left:130px;" src="/milanocortina2026/en/static/_content/8-box-2.png" />
      <img class="abs halfScaleC 8-box" style="top:138px;left:330px;" src="/milanocortina2026/en/static/_content/8-box-3.png" />

    `,
      "script": `
        function onPageEnter() {
          pg8Anim = new TimelineMax();
          pg8Anim.staggerFromTo(cOf("8-title"), 0.8, {opacity:0, y: 20}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, 1)
          .staggerFromTo(cOf("8-box"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1.6)
        }

        function onPageLeave() {
          pg8Anim.stop();
        }
      `,
      "searchText": "Get Ready Pack: Milano Cortina 2026 | Transport  Contents  8  Your transport options How to get around at the Games. You will have three main transport options available to you at Milano Cortina 2026.  Transport for Athletes (TA)  Public Transport (TP)  Transport Connect (TC)  Point-to-point service from your Village to your training/competition venues  Free access to public transport throughout the Games period  For athletes and accredited entourage members with TA entitlement – priority given to competing athletes  For athletes and eligible accredited entourage members  Extra shuttle service connecting each Village with competition venues, long-term parking areas and hotels  The easiest way to find your way around is the official Milano Cortina 2026 transport app, which will be available closer to the Games.  Getting to the games  For athletes and eligible accredited entourage members"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 8,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg9.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
      
      <img class="abs halfScale 9-title" style="top:85px;left:21px;" src="/milanocortina2026/en/static/_content/9-title-1.png"/>
      <img class="abs halfScale 9-sub" style="top:137px;left:21px;" src="/milanocortina2026/en/static/_content/9-sub-1.png"/>

      <img class="abs halfScaleC 9-village" style="top:157px;left:208px;" src="/milanocortina2026/en/static/_content/9-village-1.png" />
      <img class="abs halfScaleC 9-village" style="top:113px;left:353px;" src="/milanocortina2026/en/static/_content/9-village-2.png" />
      <img class="abs halfScaleC 9-village" style="top:243px;left:370px;" src="/milanocortina2026/en/static/_content/9-village-3.png" />
      <img class="abs halfScaleC 9-village" style="top:258px;left:247px;" src="/milanocortina2026/en/static/_content/9-village-4.png" />
      <img class="abs halfScaleC 9-village" style="top:241px;left:230px;" src="/milanocortina2026/en/static/_content/9-village-5.png" />
      <img class="abs halfScaleC 9-village" style="top:366px;left:124px;" src="/milanocortina2026/en/static/_content/9-village-6.png" />

      <div class="abs addContentLink pointer" onclick="Publish.goToPage(14)" style="top:318px;left:265px;width:84px;height:32px;"></div>
      <div class="abs addContentLink pointer" onclick="Publish.goToPage(16)" style="top:278px;left:406px;width:104px;height:32px;"></div>
      <div class="abs addContentLink pointer" onclick="Publish.goToPage(12)" style="top:391px;left:423px;width:84px;height:32px;"></div>
      <div class="abs addContentLink pointer" onclick="Publish.goToPage(15)" style="top:393px;left:288px;width:79px;height:32px;"></div>
      <div class="abs addContentLink pointer" onclick="Publish.goToPage(13)" style="top:430px;left:328px;width:97px;height:32px;"></div>
      <div class="abs addContentLink pointer" onclick="Publish.goToPage(11)" style="top:494px;left:175px;width:84px;height:32px;"></div>
      

    `,
      "script": `
        function onPageEnter() {
          pg9Anim = new TimelineMax();
          pg9Anim.fromTo(cOf("9-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("9-sub"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.2)
          .staggerFromTo(cOf("9-village"), 0.8, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1.4)

          setTimeout(function(){
            addContentLinks();
          },3000)
        }

        function onPageLeave() {
          removeContentLinks();        
          pg9Anim.stop();
        }
      `,
      "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Olympic Villages map  9  Olympic Villages map Click on your Village to find out more.  Anterselva Livigno  Bormio Predazzo Milano  Getting to the games  Cortina"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 9,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg10.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>

      <img class="abs halfScale 10-title" style="top:109px;left:181px;" src="/milanocortina2026/en/static/_content/10-title-1.png"/>
      <img class="abs halfScale 10-title" style="top:178px;left:172px;" src="/milanocortina2026/en/static/_content/10-title-2.png"/>
      <img class="abs halfScale 10-title" style="top:579px;left:181px;" src="/milanocortina2026/en/static/_content/10-sub-1.png"/>

      <div class="addContentLink" onclick="Publish.goToPage(11);" style="top:633px; left:188px; width:106px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(12);" style="top:671px; left:188px; width:106px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(13);" style="top:709px; left:188px; width:106px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(14);" style="top:633px; left:318px; width:106px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(15);" style="top:671px; left:318px; width:106px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(16);" style="top:709px; left:318px; width:106px; height:22px;"></div>

      `,
      "script": `
        function onPageEnter() {
          pg10Anim = new TimelineMax();
          pg10Anim.staggerFromTo(cOf("10-title"), 0.8, {opacity:0, x: -40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);
          setTimeout(function(){
            addContentLinks();
          },2000)
        }

        function onPageLeave() {
          pg10Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Welcome to your Village  10  WELCOME TO YOUR VILLAGE  Get to know your new home.  Welcome to your village  11 Milano  14 Livigno  12 Cortina  15 Bormio  13 Predazzo  16 Anterselva"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 10,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg11.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
      
      <img class="abs halfScale 11-title" style="top:87px;left:21px;" src="/milanocortina2026/en/static/_content/11-title-1.png"/>


      <img class="abs halfScaleC halfpulse animatedpulse 11-btn pointer" onclick="Publish.goToPage(17)" style="top:454px;left:-55px;" src="/milanocortina2026/en/static/_content/11-btn-1.png"/>


    `,
      "script": `
        function onPageEnter() {
          pg11Anim = new TimelineMax();
          pg11Anim.fromTo(cOf("11-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("11-sub"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.2)
        }

        function onPageLeave() {
          pg11Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "Get Ready Pack: Milano Cortina 2026 | Milan  Contents  11  Milan GROUND FLOOR 10 8  11 9  RAMP TO BASEMENT  12  P  VIA GIUS  5  7  4  1  TC  EPPE RI  2  700 m  PAMONT  3 RIVE E-ART DRIVPO IN  I  6  FLOORS 1-7  RIVE E-ART DRIVPO IN  NNI IOVA VIA G INI Z LOREN  R  B  R  C  R  R  D  R  E  R  F  LI  VIA PRIVATA ERCOLE MAREL  A  EXPLORE LIFE IN THE VILLAGE  Athletes and Team Officials  Unavailable area  0  Entrance/Exit  Metro Station  Transport Mall  Train Station  Pedestrian Screening Area  Polyclinic  Security Perimeter  Internal Perimeter  Lobby Entry to Residental Units  Access Control Point Vehicle Screening Area  Main Dining Hall Main Entry Address (individual deliveries)  Materials Transfer Area  Arrivals and Departures Service  TC Transport Connect  Welcome to your village  1  2  Main Entry Accreditation Centre and Guest Pass Centre  3  Luggage Tent  4  Village Plaza  5  Recreational Areas  6  Athlete365 House  7  Resident Centre  8  Fitness Centre  9  Prayer Room  10  Doping Control Station  11  Mind Zone  12  Uniform Distribution Centre  20m  FLOORS 1-7  R  Residential Units  • Athlete headshots (Building A) • Words of Olympians (Building A) FLOOR -1 Resident Laundries (all buildings)  40m"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 11,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg12.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
      
      <img class="abs halfScale 12-title" style="top:87px;left:21px;" src="/milanocortina2026/en/static/_content/12-title-1.png"/>

      <img class="abs halfScaleC halfpulse animatedpulse 12-btn pointer" onclick="Publish.goToPage(17)" style="top:427px;left:-55px;" src="/milanocortina2026/en/static/_content/11-btn-1.png"/>

    `,
      "script": `
        function onPageEnter() {
          pg12Anim = new TimelineMax();
          pg12Anim.fromTo(cOf("12-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("12-sub"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.2)
        }

        function onPageLeave() {
          pg12Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "Get Ready Pack: Milano Cortina 2026 | Cortina  Contents  12  Cortina 0  25m  P  50m  DRIVE-ARRIVE POINT  STRADA STATALE 51 DI ALEMAGNA  TC  P  CLUSTER PARKING  CORTINA D’AMPEZZO 5 KM  BUILDING 1  3 12  11  10  9  8  7  6  2  1  5  4 BUILDING 2  BUILDING 3  BUILDING 4  EXPLORE LIFE IN THE VILLAGE  Athletes and Team Officials  P  Unavailable area  Transport Mall  NOC Dedicated Parking  Wax Cabins  1 - 12  Residential Blocks  Entrance/Exit  Security Perimeter  Pedestrian Screening Area  Internal Perimeter  Vehicle Screening Area  Entry to Residental Units  BUILDING 1 • Polyclinic • Resident Laundries • Resident Centre • Recreational Areas • Doping Control Stations  • Main Dining Hall • Athlete365 House  First Floor • Prayer Room • Athlete headshots • Words of Olympians  • Team Processing Centre - Main Entry - Accreditation Centre - Guest Pass Centre - Village Plaza  BUILDING 2 • Fitness Centre • Mind Zone Materials Transfer Area  Access Control Point  Arrivals and Departures Service  (individual deliveries)  TC Transport Connect Welcome to your village  Main Entry Address  BUILDING 3  BUILDING 4"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 12,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg13.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
      
      <img class="abs halfScale 13-title" style="top:87px;left:21px;" src="/milanocortina2026/en/static/_content/13-title-1.png"/>

      <img class="abs halfScaleC halfpulse animatedpulse 13-btn pointer" onclick="Publish.goToPage(17)" style="top:460px;left:-55px;" src="/milanocortina2026/en/static/_content/11-btn-1.png"/>

    `,
      "script": `
        function onPageEnter() {
          pg13Anim = new TimelineMax();
          pg13Anim.fromTo(cOf("13-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("13-sub"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.2)
        }

        function onPageLeave() {
          pg13Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "Get Ready Pack: Milano Cortina 2026 | Predazzo  Contents  13  Predazzo TC  FLOOR +1  R  R  R  9  8  VIA AI CANZOCOI  40m  DRIVE-ARRIVE POINT  DINING HALL  TC  P BUILDING LATEMAR  BUILDING MUSTO  6  AIN  OM M  M FR  Y  ENTR  ITES  P  350  VIA MARCONI  1 2  VIA S. NICOLÒ  GROUND FLOOR  20m  R  R CORSO DE GASPERI  FLOOR +3  0  DA DO  4  STRA  5  R  LOM  NOC NPC  7  3 BUILDING NICOLAUCICH  BUILDING MACCHI BUILDING MONTE CIMONE  BUILDING OLIMPICO  VIA COL. BARBIERI  EXPLORE LIFE IN THE VILLAGE  Dedicated P NOC Parking  Security Perimeter  1  Accreditation centre  Internal Perimeter  2  Guest Pass Centre  3  Main Entry  R  Residential Units  4  Athlete365 House  8  Prayer Room  5  Recreational Areas  9  Mind Zone  Materials Transfer Area  6  Doping Control Station  • Athlete headshots • Words of Olympians  Arrivals and Departures Service  7  Resident Centre  Athletes and Team Officials  Unavailable area Entrance/Exit Transport Mall Main Dining Hall  Entry to Residental Units  Polyclinic  Access Control Point  Resident laundries  Main Entry Address  Pedestrian Screening Area  Vehicle Screening Area  TC Transport Connect  Welcome to your village  FLOOR -1 (Building Musto) Fitness Centre  FLOORS 1-3  (individual deliveries)"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 13,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg14.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
      
      <img class="abs halfScale 14-title" style="top:87px;left:21px;" src="/milanocortina2026/en/static/_content/14-title-1.png"/>

      <img class="abs halfScaleC halfpulse animatedpulse 14-btn pointer" onclick="Publish.goToPage(17)" style="top:425px;left:-55px;" src="/milanocortina2026/en/static/_content/11-btn-1.png"/>

    `,
      "script": `
        function onPageEnter() {
          pg14Anim = new TimelineMax();
          pg14Anim.fromTo(cOf("14-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("14-sub"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.2)
        }

        function onPageLeave() {
          pg14Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Livigno  CHARME HOTEL ALEXANDER  VI A  FR  EI TA  Livigno  14  VIA  GE RU  S  ALPEN RESORT BIVIO HOTEL  WORKFORCE CENTRE  TC  P  DR IV E PO -A IN RR T IV  E  ACCREDITATION CENTRE & GUEST PASS CENTRE  INTERMONTI HOTEL  EXPLORE LIFE IN THE VILLAGE  Athletes and Team Officials  0  P NOC Dedicated Parking  Unavailable area  Entry to Residental Units  Transport Mall  Access Control Point  Alpen Resort Bivio Hotel  Intermonti Hotel  Main Entry (PSA) Accreditation Centre and Guest Pass Centre Village Plaza Main Dining Hall  Entrance/Exit  Pedestrian Screening Area  Main Entry Address  (individual deliveries)  Residential Units Resident Centre Fitness Centre Recreational Areas  Vehicle Screening Area  Resident Laundries  TBD  Medical Facility Materials Transfer Area  Prayer Room Transport Mall  Arrivals and Departures Service  Athlete365 House Mind Zone Doping Control Station  TC Transport Connect  Welcome to your village  TBD  Charme Hotel Alexander  10m  Remote Location  20m"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 14,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg15.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
      
      <img class="abs halfScale 15-title" style="top:87px;left:21px;" src="/milanocortina2026/en/static/_content/15-title-1.png"/>

      <img class="abs halfScaleC halfpulse animatedpulse 15-btn pointer" onclick="Publish.goToPage(17)" style="top:369px;left:-55px;" src="/milanocortina2026/en/static/_content/11-btn-1.png"/>

    `,
      "script": `
        function onPageEnter() {
          pg15Anim = new TimelineMax();
          pg15Anim.fromTo(cOf("15-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("15-sub"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.2)
        }

        function onPageLeave() {
          pg15Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "Get Ready Pack: Milano Cortina 2026 | Bormio  15  GU IC CI AR DI  Contents  VI A  CO LO N  NE  LL O  DI E  GO  Bormio  BAITA CLEMENTI HOTEL  PALACE HOTEL  CRISTALLO HOTEL  VIA  SS  IA  -V  NO  LA  MI  DA AD  MIRAMONTI PARK HOTEL  VIA I CH  N RO  ACCREDITATION CENTRE  E  RIV AR E- T IV POIN  DR  P TC  EXPLORE LIFE IN THE VILLAGE  Palace Hotel  Athletes and Team Officials  Unavailable area  Athletes and Team Officials, Guests and Press  0  Miramonti Park Hotel  Baita Clementi Hotel  Accreditation Centre Main Entry Secondary Entry Guest Pass Centre Village Plaza  Transport Mall  Main Dining Hall Residential Units  Pedestrian Screening Area  Resident Centre Fitness Centre  Materials Transfer Area  Recreational Areas Resident Laundries  Entrance/Exit  Medical Facility Prayer Room  Arrivals and Departures Service  TC  Transport Connect  Athlete365 House Mind Zone Doping Control Station  Access Control Point  Main Entry Address  Welcome to your village  P  NOC Dedicated Parking  TBD  Cristallo Hotel  Remote location  10m  20m"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 15,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg16.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
      
      <img class="abs halfScale 16-title" style="top:87px;left:21px;" src="/milanocortina2026/en/static/_content/16-title-1.png"/>

      <img class="abs halfScaleC halfpulse animatedpulse 16-btn pointer" onclick="Publish.goToPage(17)" style="top:451px;left:-55px;" src="/milanocortina2026/en/static/_content/11-btn-1.png"/>

    `,
      "script": `
        function onPageEnter() {
          pg16Anim = new TimelineMax();
          pg16Anim.fromTo(cOf("16-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("16-sub"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.2)
        }

        function onPageLeave() {
          pg16Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Anterselva  16  Anterselva  TA  GARBERHOF HOTEL  RASUN DI SOTTO  ALPENHOF HOTEL  VI A  VA  LL  ED  ’A N  TE  RS  EL  VA  ST RA DA  PR OV  IN C  IA LE 44  ANTERSELVA BIATHLON ARENA 15KM  CLUSTER CONNECTION CENTRE (CCC)  TA  AUTENTIS HOTEL BRUNNERHOF HOTEL  EXPLORE LIFE IN THE VILLAGE  Garberhof Hotel  Athletes and Team Officials  Unavailable area  Athletes and Team Officials, Guests and Press  Transport Mall  TA  Transport for Athletes  Pedestrian Screening Area  0  TA  Alpenhof Hotel  Brunnerhof Hotel  Autentis Hotel  10m  Remote location  Main Entry (PSA) Cluster Connection Centre (CCC) Guest Pass Centre Main Dining Hall Residential Units Resident Centre Fitness Centre Recreational Areas Resident Laundries Medical Facility  Polyclinic  Prayer Room Materials Transfer Area  Entrance/Exit  Entry to Residental Units  Welcome to your village  Athlete365 House  ABA  Mind Zone  ABA  20m"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 16,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg17.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>

      <img class="abs halfScale 17-title" style="top:107px;left:245px;" src="/milanocortina2026/en/static/_content/17-title-1.png"/>
      <img class="abs halfScale 17-title" style="top:177px;left:189px;" src="/milanocortina2026/en/static/_content/17-title-2.png"/>
      <img class="abs halfScale 17-title" style="top:581px;left:122px;" src="/milanocortina2026/en/static/_content/17-sub-1.png"/>

      <div class="addContentLink" onclick="Publish.goToPage(18);" style="top:633px; left:98px; width:176px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(19);" style="top:671px; left:98px; width:176px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(20);" style="top:709px; left:98px; width:176px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(22);" style="top:749px; left:98px; width:176px; height:36px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(23);" style="top:633px; left:321px; width:206px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(24);" style="top:671px; left:321px; width:206px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(25);" style="top:709px; left:321px; width:206px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(26);" style="top:747px; left:321px; width:206px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(27);" style="top:786px; left:321px; width:206px; height:22px;"></div>

      `,
      "script": `
        function onPageEnter() {
          pg17Anim = new TimelineMax();
          pg17Anim.staggerFromTo(cOf("17-title"), 0.8, {opacity:0, x: -40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);
          setTimeout(function(){
            addContentLinks();
          },2000)
        }

        function onPageLeave() {
          pg17Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Life in the Village  17  Life in the village  Find out what's happening in your Village. 18 Olympic Village services  23 Believe in Sport ambassadors  19 Athlete365 House  24 Pamper yourself with P&G  20 IOC AC election  25 Paying with Visa  22 A thlete365 x  26 Your Golden Moment  Powerade Mind Zone  Life in the village  27 Eating and drinking"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 17,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg18.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
      
      <img class="abs halfScale 18-title" style="top:86px;left:23px;" src="/milanocortina2026/en/static/_content/18-title-1.png"/>
      <img class="abs halfScale 18-title" style="top:138px;left:23px;" src="/milanocortina2026/en/static/_content/18-title-2.png"/>
      <img class="abs halfScale 18-title" style="top:190px;left:23px;" src="/milanocortina2026/en/static/_content/18-title-3.png"/>
      <img class="abs halfScale 18-sub" style="top:253px;left:21px;" src="/milanocortina2026/en/static/_content/18-sub-1.png"/>

      <a href="https://www.olympics.com/athlete365/articles/milano-cortina2026/your-olympic-village-services-at-milano-cortina-2026" target="_blank">
        <img class="abs halfScaleC halfpulse animatedpulse 18-btn" style="top:301px;left:-23px;" src="/milanocortina2026/en/static/_content/18-btn-1.png"/>
      </a>

      <img class="abs halfScale 18-greenbox" style="top:87px;left:302px;" src="/milanocortina2026/en/static/_content/18-greenbox.png" />
      <img class="abs halfScale 18-bottom-bar-1" style="top:832px;left:-35px;" src="/milanocortina2026/en/static/_content/18-bottom-bar-1.png" />

      <img class="abs halfScaleC 18-icon" style="top:75px;left:275px;" src="/milanocortina2026/en/static/_content/18-icon-1.png" />
      <img class="abs halfScaleC 18-icon" style="top:199px;left:275px;" src="/milanocortina2026/en/static/_content/18-icon-2.png" />
      <img class="abs halfScaleC 18-icon" style="top:323px;left:275px;" src="/milanocortina2026/en/static/_content/18-icon-3.png" />
      <img class="abs halfScaleC 18-icon" style="top:447px;left:275px;" src="/milanocortina2026/en/static/_content/18-icon-4.png" />
      <img class="abs halfScaleC 18-icon" style="top:571px;left:275px;" src="/milanocortina2026/en/static/_content/18-icon-5.png" />
      <img class="abs halfScaleC 18-icon" style="top:695px;left:275px;" src="/milanocortina2026/en/static/_content/18-icon-6.png" />

      <img class="abs halfScale 18-text" style="top:109px;left:417px;" src="/milanocortina2026/en/static/_content/18-text-1.png"/>
      <img class="abs halfScale 18-text" style="top:255px;left:417px;" src="/milanocortina2026/en/static/_content/18-text-2.png"/>
      <img class="abs halfScale 18-text" style="top:371px;left:417px;" src="/milanocortina2026/en/static/_content/18-text-3.png"/>
      <img class="abs halfScale 18-text" style="top:495px;left:417px;" src="/milanocortina2026/en/static/_content/18-text-4.png"/>
      <img class="abs halfScale 18-text" style="top:633px;left:417px;" src="/milanocortina2026/en/static/_content/18-text-5.png"/>
      <img class="abs halfScale 18-text" style="top:757px;left:417px;" src="/milanocortina2026/en/static/_content/18-text-6.png"/>

    `,
      "script": `
        function onPageEnter() {
          pg18Anim = new TimelineMax();
          pg18Anim.staggerFromTo(cOf("18-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .fromTo(cOf("18-greenbox"), 1, {opacity:0, x: 120}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.4)
          .fromTo(cOf("18-sub"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.6)
          .staggerFromTo(cOf("18-icon"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.8)
          .staggerFromTo(cOf("18-text"), 0.7, {opacity:0, x: 20}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 0.1, 1.9)
          
        }

        function onPageLeave() {
          pg18Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Olympic Village services  Olympic Village services Here’s what you will find in your Olympic Village.  18  Medical services  Medical services will be available in each Village, with varying levels of service, including external locations supported by arranged transport. Accredited entourage members are eligible only in emergencies.  Fitness Centre  Gym with equipment tailored to the specific sports represented in the Village.  Find out more Laundry  Self-service laundry stocked with Dash Laundry Detergent, Lenor Fabric Conditioner and Lenor In-wash Scent Booster from P&G.  Resident Centre  Get assistance with any accommodation issues, including housekeeping requests, emergency maintenance and lost property.  Recreational area  Relax and have fun with a variety of entertainment activities.  Prayer room  A quiet space for meditation and worship.  Life in the village"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 18,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg19.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
      
      <img class="abs halfScale 19-title" style="top:85px;left:20px;" src="/milanocortina2026/en/static/_content/19-title-1.png"/>
      <img class="abs halfScale 19-title" style="top:138px;left:20px;" src="/milanocortina2026/en/static/_content/19-title-2.png"/>
      <img class="abs halfScale 19-title" style="top:201px;left:20px;" src="/milanocortina2026/en/static/_content/19-sub-1.png"/>

      <a href="https://www.olympics.com/athlete365/articles/milano-cortina2026/everything-you-need-to-know-about-athlete365-house-at-milano-cortina-2026 " target="_blank">
        <img class="abs halfScaleC halfpulse animatedpulse 19-btn" style="top:791px;left:-21px;" src="/milanocortina2026/en/static/_content/19-btn-1.png"/>
      </a>

    `,
      "script": `
        function onPageEnter() {
          pg19Anim = new TimelineMax();
          pg19Anim.staggerFromTo(cOf("19-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 0.2, 1)
        }

        function onPageLeave() {
          pg19Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Athlete365 House  19  Athlete365 House Connect with other athletes, access support programmes, learn about key topics and vote in the IOC Athletes’ Commission election – all at Athlete365 House! Thoughtfully designed for you to get involved in rewarding activities, share your voice, create memories with other athletes, and collect limitededition freebies, Athlete365 House will be in every Village at Milano Cortina 2026. With six areas to explore, here’s what you can expect:  Play  Empower  Celebrate Commemorate your Games experience with souvenir photos  Life in the village  Vote in the IOC Athletes’ Commission election  Connect  Learn about the prevention of competition manipulation and antidoping  Find out more  Act  Play PinQuest and win special prizes Join the Athlete365 community, access our exclusive offers and learn about the Olympic Solidarity opportunities available to you  Excite Watch live competitions with other athletes"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 19,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg20.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
      
      <img class="abs halfScale 20-title" style="top:151px;left:19px;" src="/milanocortina2026/en/static/_content/20-title-1.png"/>
      <img class="abs halfScale 20-title" style="top:218px;left:18px;" src="/milanocortina2026/en/static/_content/20-title-2.png"/>
      <img class="abs halfScale 20-title" style="top:299px;left:21px;" src="/milanocortina2026/en/static/_content/20-sub-1.png"/>

      <a href="https://www.olympics.com/athlete365/articles/milano-cortina2026/ioc-athletes-commission-election-milano-cortina-2026 " target="_blank">
        <img class="abs halfScaleC halfpulse animatedpulse 3-btn" style="top:778px;left:-23px;" src="/milanocortina2026/en/static/_content/20-btn-1.png"/>
      </a>

    `,
      "script": `
        function onPageEnter() {
          pg20Anim = new TimelineMax();
          pg20Anim.staggerFromTo(cOf("20-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 0.2, 1)
        }

        function onPageLeave() {
          pg20Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "Get Ready Pack: Milano Cortina 2026 | IOC Athletes' Commission election  Contents  Vote in the IOC Athletes’ Commission Election Have your say in who represents you within the Olympic Movement. Two athletes from two different sports will be elected to the IOC Athletes’ Commission (AC) at Milano Cortina 2026. All accredited athletes (Aa) are eligible to vote – don’t miss this chance to use your voice.  What is the IOC AC? The IOC AC’s mission is to represent you within the Olympic Movement, support you so they can succeed in your sporting and non-sporting careers, and empower the global network of athlete representatives.  Who is standing? There are 11 candidates standing in the election, representing 11 National Olympic Committees and five sports. Find out more about your candidates on the next page.  When and where can I vote? Election dates: 30 January–18 February Location: Voting booths at Athlete365 House in each Village  Find out more Life in the village  20"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 20,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg21.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
      
      <img class="abs halfScale 21-title" style="top:151px;left:19px;" src="/milanocortina2026/en/static/_content/21-title-1.png"/>

      <img class="abs halfScale 21-candidate" style="top:255px;left:21px;" src="/milanocortina2026/en/static/_content/21-candidate-1.png"/>
      <img class="abs halfScale 21-candidate" style="top:255px;left:118px;" src="/milanocortina2026/en/static/_content/21-candidate-2.png"/>
      <img class="abs halfScale 21-candidate" style="top:255px;left:216px;" src="/milanocortina2026/en/static/_content/21-candidate-3.png"/>
      <img class="abs halfScale 21-candidate" style="top:255px;left:314px;" src="/milanocortina2026/en/static/_content/21-candidate-4.png"/>
      <img class="abs halfScale 21-candidate" style="top:255px;left:411px;" src="/milanocortina2026/en/static/_content/21-candidate-5.png"/>
      <img class="abs halfScale 21-candidate" style="top:274px;left:509px;" src="/milanocortina2026/en/static/_content/21-candidate-6.png"/>

      <img class="abs halfScale 21-candidate" style="top:530px;left:21px;" src="/milanocortina2026/en/static/_content/21-line.png"/>
      <img class="abs halfScale 21-candidate" style="top:536px;left:21px;" src="/milanocortina2026/en/static/_content/21-candidate-7.png"/>
      <img class="abs halfScale 21-candidate" style="top:536px;left:118px;" src="/milanocortina2026/en/static/_content/21-candidate-8.png"/>
      <img class="abs halfScale 21-candidate" style="top:536px;left:216px;" src="/milanocortina2026/en/static/_content/21-candidate-9.png"/>
      <img class="abs halfScale 21-candidate" style="top:536px;left:314px;" src="/milanocortina2026/en/static/_content/21-candidate-10.png"/>
      <img class="abs halfScale 21-candidate" style="top:536px;left:411px;" src="/milanocortina2026/en/static/_content/21-candidate-11.png"/>

    `,
      "script": `
        function onPageEnter() {
          pg21Anim = new TimelineMax();
          pg21Anim.fromTo(cOf("21-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .staggerFromTo(cOf("21-candidate"), 0.8, {opacity:0, y: 20}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.1, 1)
        }

        function onPageLeave() {
          pg21Anim.stop();
        }
      `,
      "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | IOC Athletes' Commission election  21  Meet your candidates biathlon  Bobsleigh  EST  KOR  Johanna TALIHÄRM  Yunjong WON  SUI  TLS  Dario cologna  Life in the village  Yohan GONcALVES GOUTT  Curling  Skating  NOR  Magnus NEDREGOTTEN  FIN  Ilkka HEROLA  CHN  Cong HAN  HUN  Ádám KÓNYA  Skiing  UKR  KAZ  Oleksandr ABRAMENKO  Zhanbota ALDABERGENOVA  CAN  Marielle THOMPSON"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 21,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg22.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
      
      <img class="abs halfScale 22-title" style="top:86px;left:21px;" src="/milanocortina2026/en/static/_content/22-title-1.png"/>
      <img class="abs halfScale 22-title" style="top:137px;left:21px;" src="/milanocortina2026/en/static/_content/22-title-2.png"/>
      <img class="abs halfScale 22-sub" style="top:200px;left:22px;" src="/milanocortina2026/en/static/_content/22-sub-1.png"/>

      <a href="https://www.olympics.com/athlete365/news/mentally-fit/relax-and-recharge-at-the-athlete365-x-powerade-mind-zone " target="_blank">
        <img class="abs halfScaleC halfpulse animatedpulse 22-btn" style="top:418px;left:-23px;" src="/milanocortina2026/en/static/_content/22-btn-1.png"/>
      </a>

      <a href="https://www.olympics.com/athlete365/offers/mentally-fit/free-mindfulness-app-subscription" target="_blank">
        <img class="abs halfScaleC halfpulse animatedpulse 22-btn" style="top:390px;left:436px;" src="/milanocortina2026/en/static/_content/22-btn-2.png"/>
      </a>

    `,
      "script": `
        function onPageEnter() {
          pg22Anim = new TimelineMax();
          pg22Anim.staggerFromTo(cOf("22-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .fromTo(cOf("22-sub"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.4)
        }

        function onPageLeave() {
          pg22Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Athlete365 X Powerade Mind Zone  22  Athlete365 x Powerade Mind Zone Relax, recharge and mentally prepare to compete at your best. First introduced at Paris 2024, the Athlete365 x Powerade Mind Zone is a groundbreaking initiative that helps you prioritise your mental health during the Olympic Games. • Relax with a virtual reality mindfulness experience* • Disconnect and inspire your creativity with art activities • Unwind and de-stress with breathing exercises • Have a confidential chat with a qualified IOC safeguarding officer** Delivered in partnership with Worldwide Olympic Partner Coca-Cola, the Mind Zone is also stocked with Powerade products to aid your recovery.  Did you know? You can get a free one-year premium subscription to a leading mindfulness app with Athlete365.  Access offer  Find out more *Mind Zone in Bormio will not have the VR experience. **Mind Zone in Bormio will not be staffed but contact information for mental health and safeguarding support will be available.  Life in the village"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 22,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg23.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
      
      <img class="abs halfScale 23-title" style="top:126px;left:23px;" src="/milanocortina2026/en/static/_content/23-title-1.png"/>
      <img class="abs halfScale 23-title" style="top:178px;left:22px;" src="/milanocortina2026/en/static/_content/23-title-2.png"/>
      <img class="abs halfScale 23-sub" style="top:240px;left:20px;" src="/milanocortina2026/en/static/_content/23-sub-1.png"/>

      <img class="abs halfScaleC 23-img" style="top:252px;left:243px;" src="/milanocortina2026/en/static/_content/23-img-1.png"/>
      <img class="abs halfScaleC 23-img" style="top:252px;left:348px;" src="/milanocortina2026/en/static/_content/23-img-2.png"/>
      <img class="abs halfScaleC 23-img" style="top:252px;left:453px;" src="/milanocortina2026/en/static/_content/23-img-3.png"/>

      <a href="https://www.olympics.com/athlete365/articles/believeinsport/meet-your-believe-in-sport-ambassadors-for-milano-cortina-2026 " target="_blank">
        <img class="abs halfScaleC halfpulse animatedpulse 23-btn" style="top:531px;left:-86px;" src="/milanocortina2026/en/static/_content/23-btn-1.png"/>
      </a>

      <a href="https://www.olympics.com/athlete365/topics/believeinsport?nxtPpath=believeinsport" target="_blank">
        <img class="abs halfScaleC halfpulse animatedpulse 23-btn" style="top:577px;left:-77px;" src="/milanocortina2026/en/static/_content/23-btn-2.png"/>
      </a>

      <a href="https://www.olympics.com/athlete365/articles/believeinsport/prevention-of-competition-manipulation-international-federations-directory " target="_blank">
        <img class="abs halfScaleC halfpulse animatedpulse 23-btn" style="top:764px;left:-42px;" src="/milanocortina2026/en/static/_content/23-btn-3.png"/>
      </a>

    `,
      "script": `
        function onPageEnter() {
          pg23Anim = new TimelineMax();
          pg23Anim.staggerFromTo(cOf("23-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .staggerFromTo(cOf("23-img"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.15, 1.2)
          .fromTo(cOf("23-sub"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.4)
        }

        function onPageLeave() {
          pg23Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Believe in Sport ambassadors  Meet your Believe in Sport ambassadors The Believe in Sport campaign raises awareness about the threat of competition manipulation. As part of the IOC’s Believe in Sport campaign, three ambassadors have been chosen for Milano Cortina 2026: Mark Fraser, Yura Min and Dominik Windisch. They will be present at the Believe in Sport booth in Athlete365 House in Milan and Cortina from 30 January to 23 February. Head down to the booth to find out more about the prevention of competition manipulation and have a go at an interactive game to take home a special souvenir.  Learn more about your ambassadors Learn more about Believe in Sport We want you to feel confident in spotting the warning signs and know exactly what you can do to protect the integrity of sport. To find out what your sport is doing to prevent competition manipulation, head to our International Federations Directory.  Access the directory  Life in the village  23"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 23,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg24.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
      
      <img class="abs halfScale 24-title" style="top:142px;left:21px;" src="/milanocortina2026/en/static/_content/24-title-1.png"/>
      <img class="abs halfScale 24-title" style="top:193px;left:21px;" src="/milanocortina2026/en/static/_content/24-title-2.png"/>
      <img class="abs halfScale 24-title" style="top:245px;left:21px;" src="/milanocortina2026/en/static/_content/24-title-3.png"/>
      <img class="abs halfScale 24-sub" style="top:308px;left:22px;" src="/milanocortina2026/en/static/_content/24-sub-1.png"/>

      <a href="https://www.olympics.com/athlete365/news/milano-cortina2026/calling-all-parent-athletes-aiming-for-milano-cortina-2026" target="_blank">
        <img class="abs halfScaleC halfpulse animatedpulse 24-btn" style="top:760px;left:-23px;" src="/milanocortina2026/en/static/_content/24-btn-1.png"/>
      </a>

    `,
      "script": `
        function onPageEnter() {
          pg24Anim = new TimelineMax();
          pg24Anim.staggerFromTo(cOf("24-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .fromTo(cOf("24-sub"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.6)
        }

        function onPageLeave() {
          pg24Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Pamper yourself with P&G  24  Pamper yourself with P&G P&G’s leading brands are here to help you feel your best during the Games. P&G Champions Clubhouse For athletes in the Milan Olympic Village, head to the P&G Champions Clubhouse to treat yourself to beauty and grooming services, take part in gaming competitions and cultural celebrations with fellow athletes, and receive exclusive giveaways.  Pampers Kit for parents  Are you an athlete with a baby or young child travelling with you to the Games? Pick up your Pampers Kit, designed to support your family during your stay at the Games with high-quality nappies/diapers, wipes and a few other surprises for your little one. If you haven’t done so already, sign up here to register your interest.  Register here  Life in the village  Athlete Welcome Kit  To welcome you to Milano Cortina 2026, all athletes will receive a thoughtfully curated Athlete Welcome Kit, packed with premium products to ensure you feel your best as you compete on the world stage."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 24,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg25.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
      
      <img class="abs halfScale 25-title" style="top:158px;left:21px;" src="/milanocortina2026/en/static/_content/25-title-1.png"/>
      <img class="abs halfScale 25-sub" style="top:220px;left:22px;" src="/milanocortina2026/en/static/_content/25-sub-1.png"/>

    `,
      "script": `
        function onPageEnter() {
          pg25Anim = new TimelineMax();
          pg25Anim.staggerFromTo(cOf("25-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .fromTo(cOf("25-sub"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.2)
        }

        function onPageLeave() {
          pg25Anim.stop();
        }
      `,
      "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Paying with Visa  Paying with Visa As part of Visa’s longstanding partnership with the Olympic and Paralympic Games, Milano Cortina 2026 accepts only Visa for card payments, along with cash, at Olympic venues and Villages to pay for food, beverages and official licensed products.  Get ready for the Games. Contact your bank and request a Visa card now.  Life in the village  25"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 25,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg26.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
      
      <img class="abs halfScale 26-title" style="top:557px;left:21px;" src="/milanocortina2026/en/static/_content/26-title-1.png"/>
      <img class="abs halfScale 26-sub" style="top:621px;left:22px;" src="/milanocortina2026/en/static/_content/26-sub-1.png"/>

    `,
      "script": `
        function onPageEnter() {
          pg26Anim = new TimelineMax();
          pg26Anim.staggerFromTo(cOf("26-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .fromTo(cOf("26-sub"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.2)
        }

        function onPageLeave() {
          pg26Anim.stop();
        }
      `,
      "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Your Golden Moment  mark Your Golden Moment Celebrate your time at the Games with a Corona Golden Bottle. For athletes in the Milan and Cortina Villages, head to the Corona Greenroom to relax before competition, recharge afterwards, and celebrate your achievements. Here, you can customise and pick up your Corona Golden Bottle, a unique symbol of  Life in the village  your journey, ready to be engraved with the golden moment that defined your Games. If you are staying in Predazzo, Livigno, Bormio, or Anterselva, you can personalise your Golden Bottle online and have it delivered to you. Stay tuned.  26"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 26,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg27.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
      
      <img class="abs halfScale 27-title" style="top:85px;left:21px;" src="/milanocortina2026/en/static/_content/27-title-1.png"/>
      <img class="abs halfScale 27-sub" style="top:148px;left:22px;" src="/milanocortina2026/en/static/_content/27-sub-1.png"/>

    `,
      "script": `
        function onPageEnter() {
          pg27Anim = new TimelineMax();
          pg27Anim.staggerFromTo(cOf("27-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .fromTo(cOf("27-sub"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.2)
        }

        function onPageLeave() {
          pg27Anim.stop();
        }
      `,
      "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Eating and drinking  Eating and drinking Your food and beverage options at the Games have been carefully designed to offer you high-quality meals tailored to your dietary and nutritional requirements.  Olympic Villages • The Main Dining Areas in each Village will operate for 24 hours a day • Specific menus available for breakfast, lunch and dinner • Options will rotate over five days and offer a diverse selection • Vegetarian, vegan and glutenfree options always available • Water, isotonic drinks, juices and soft drinks from CocaCola available throughout the Village  Competition venues • The Athletes’ Lounge at each venue will offer light refreshments • Meals will be provided if you’re at the venue for more than four hours • Enhanced meals will be provided for certain disciplines • Water and Powerade available on field of play; other CocaCola products available in Athletes’ Lounge Life in the village  27"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 27,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg28.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>

      <img class="abs halfScale 28-title" style="top:107px;left:124px;" src="/milanocortina2026/en/static/_content/28-title-1.png"/>
      <img class="abs halfScale 28-title" style="top:176px;left:115px;" src="/milanocortina2026/en/static/_content/28-title-2.png"/>
      <img class="abs halfScale 28-title" style="top:580px;left:76px;" src="/milanocortina2026/en/static/_content/28-sub-1.png"/>

      <div class="addContentLink" onclick="Publish.goToPage(29);" style="top:633px; left:57px; width:157px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(30);" style="top:671px; left:57px; width:157px; height:37px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(31);" style="top:721px; left:57px; width:157px; height:24px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(32);" style="top:759px; left:57px; width:157px; height:38px;"></div>

      <div class="addContentLink" onclick="Publish.goToPage(33);" style="top:633px; left:231px; width:168px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(34);" style="top:672px; left:231px; width:168px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(35);" style="top:709px; left:231px; width:168px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(36);" style="top:746px; left:231px; width:168px; height:22px;"></div>

      <div class="addContentLink" onclick="Publish.goToPage(37);" style="top:633px; left:406px; width:168px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(38);" style="top:672px; left:406px; width:168px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(39);" style="top:709px; left:406px; width:168px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(40);" style="top:746px; left:406px; width:168px; height:22px;"></div>
      `,
      "script": `
        function onPageEnter() {
          pg28Anim = new TimelineMax();
          pg28Anim.staggerFromTo(cOf("28-title"), 0.8, {opacity:0, x: -40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);
          setTimeout(function(){
            addContentLinks();
          },2000)
        }

        function onPageLeave() {
          pg28Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Maximising your Games experience  28  MAXIMISING YOUR GAMES EXPERIENCE  Make the most of your time at Milano Cortina 2026. 29 Airbnb500  33 Social media verification 37 PinQuest  30 Olympic Edition  34 Online abuse protection 38 How to access tickets  Samsung phone  31 Athlete Moment 32 Capture your  Olympic experience  Maximising your Games experience  35 Athlete365 app  39 Opening Ceremony  36 Athlete365 Learning  40 Get Set - Train Smarter"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 28,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg29.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>

      <img class="abs halfScaleC 29-relax" style="top:189px;left:184px;" src="/milanocortina2026/en/static/_content/29-relax-1.png" />
      <div id="29-sig" class="abs noOverflow" style="top:171px;left:219px;width:80px;height:73px;background-color:#e6dae6;"></div>

      <img class="abs halfScale 29-title" style="top:226px;left:21px;" src="/milanocortina2026/en/static/_content/29-title-1.png"/>
      <img class="abs halfScale 29-title" style="top:281px;left:21px;" src="/milanocortina2026/en/static/_content/29-title-2.png"/>
      <img class="abs halfScale 29-title" style="top:330px;left:21px;" src="/milanocortina2026/en/static/_content/29-title-3.png"/>

      <img class="abs halfScaleC 29-scribble" style="top:224px;left:132px;" src="/milanocortina2026/en/static/_content/29-scribble-1.png" />

      <a href="https://www.olympics.com/athlete365/articles/airbnb500/the-airbnb500" target="_blank">
        <img class="abs halfScaleC halfpulse animatedpulse 29-btn" style="top:377px;left:261px;" src="/milanocortina2026/en/static/_content/29-btn-1.png"/>
      </a>

    `,
      "script": `
        function onPageEnter() {
          pg29Anim = new TimelineMax();
          pg29Anim.staggerFromTo(cOf("29-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .fromTo(cOf("29-scribble"), 0.5, {scale: 0}, {scale:0.45, ease: Back.easeOut.config(1.2)}, 2.5)
          .fromTo(idOf("29-sig"), 0.8, {width:80,x:0}, {width: 0,x:80, ease: Power2.easeOut}, 3)
        }

        function onPageLeave() {
          pg29Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Airbnb500  Rela  READY, SET, GO WITH a USD 500 AIRBNB GRANT  x  29  Take a moment to rest and recover after the Games with a USD 500 Airbnb Travel Grant, available only to Olympians and Paralympians competing at Milano Cortina 2026. Claim your grant from 30 January to 20 April 2026 by registering online or going to Athlete365 House in your Olympic Village. Additional terms and conditions apply.  FIND OUT MORE  Maximising your Games experience"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 29,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg30.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
      
      <img class="abs halfScale 30-title" style="top:128px;left:21px;" src="/milanocortina2026/en/static/_content/30-title-1.png"/>
      <img class="abs halfScale 30-sub" style="top:191px;left:21px;" src="/milanocortina2026/en/static/_content/30-sub-1.png"/>

      <img class="abs halfScaleC 30-icon" style="top:425px;left:356px;" src="/milanocortina2026/en/static/_content/30-icon-1.png" />
      <img class="abs halfScaleC 30-icon" style="top:488px;left:356px;" src="/milanocortina2026/en/static/_content/30-icon-2.png" />
      <img class="abs halfScaleC 30-icon" style="top:548px;left:356px;" src="/milanocortina2026/en/static/_content/30-icon-3.png" />
      <img class="abs halfScaleC 30-icon" style="top:609px;left:356px;" src="/milanocortina2026/en/static/_content/30-icon-4.png" />
      <img class="abs halfScaleC 30-icon" style="top:670px;left:356px;" src="/milanocortina2026/en/static/_content/30-icon-5.png" />
      <img class="abs halfScaleC 30-icon" style="top:731px;left:356px;" src="/milanocortina2026/en/static/_content/30-icon-6.png" />

      <img class="abs halfScale 30-text" style="top:464px;left:446px;" src="/milanocortina2026/en/static/_content/30-text-1.png"/>
      <img class="abs halfScale 30-text" style="top:534px;left:446px;" src="/milanocortina2026/en/static/_content/30-text-2.png"/>
      <img class="abs halfScale 30-text" style="top:595px;left:446px;" src="/milanocortina2026/en/static/_content/30-text-3.png"/>
      <img class="abs halfScale 30-text" style="top:656px;left:446px;" src="/milanocortina2026/en/static/_content/30-text-4.png"/>
      <img class="abs halfScale 30-text" style="top:716px;left:446px;" src="/milanocortina2026/en/static/_content/30-text-5.png"/>
      <img class="abs halfScale 30-text" style="top:763px;left:446px;" src="/milanocortina2026/en/static/_content/30-text-6.png"/>

      <a href="https://athlete365.org/samsung-offer" target="_blank">
        <img class="abs halfScaleC halfpulse animatedpulse 29-btn" style="top:357px;left:-23px;" src="/milanocortina2026/en/static/_content/33-btn-1.png"/>
      </a>

    `,
      "script": `
        function onPageEnter() {
          pg30Anim = new TimelineMax();
          pg30Anim.staggerFromTo(cOf("30-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .fromTo(cOf("30-sub"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.2)
          .staggerFromTo(cOf("30-icon"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.4)
          .staggerFromTo(cOf("30-text"), 0.7, {opacity:0, x: 20}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.1, 1.5)
          
        }

        function onPageLeave() {
          pg30Anim.stop();
        }
      `,
      "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Olympic Edition Samsung phone  30  YOUR OLYMPIC EDITION PHONE All athletes competing at Milano Cortina 2026 will receive an exclusive Samsung Galaxy Z Flip7 Olympic Edition phone. As a Worldwide Olympic Partner for nearly 30 years, Samsung is proud to bring you a Samsung Galaxy Z Flip7 Olympic Edition phone – designed exclusively for athletes at Milano Cortina 2026. To help you make the most of your time at the Games, your phone will come with several essential apps pre-installed, including including Athlete365, Milano Cortina 2026 and Galaxy Athlete Card. You can also use a free eSIM with data, calls and texts upon activation.  FIND OUT MORE  What makes it special?  Exclusive design and user experience  Samsung Galaxy AI  Olympic applications  Special accessories  2-year global warranty  Coca-Cola free drink key & discount coupons  Maximising your Games experience"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 30,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg31.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
      
      <img class="abs halfScale 31-title" style="top:85px;left:21px;" src="/milanocortina2026/en/static/_content/31-title-1.png"/>
      <img class="abs halfScale 31-title" style="top:138px;left:21px;" src="/milanocortina2026/en/static/_content/31-title-2.png"/>
      <img class="abs halfScale 31-title" style="top:190px;left:21px;" src="/milanocortina2026/en/static/_content/31-title-3.png"/>
      <img class="abs halfScale 31-sub" style="top:252px;left:21px;" src="/milanocortina2026/en/static/_content/31-sub-1.png"/>
      <img class="abs halfScale 31-sub" style="top:292px;left:21px;" src="/milanocortina2026/en/static/_content/31-sub-2.png"/>

      <a href="https://athlete365.org/athlete-moment-mico" target="_blank">
        <img class="abs halfScaleC halfpulse animatedpulse 29-btn" style="top:739px;left:-23px;" src="/milanocortina2026/en/static/_content/33-btn-1.png"/>
      </a>

    `,
      "script": `
        function onPageEnter() {
          pg31Anim = new TimelineMax();
          pg31Anim.staggerFromTo(cOf("31-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .staggerFromTo(cOf("31-sub"), 0.8, {opacity:0, y: 20}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, 1.6)
        }

        function onPageLeave() {
          pg31Anim.stop();
        }
      `,
      "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Athlete Moment  31  Celebrate with loved ones around the world Do you have family and friends who can’t be at the Games? Connect with them after your event with the Athlete Moment, presented by TCL. How does it work? 1S  ign up and share your private link with loved ones 2 Loved ones join video call at specified time 3 Celebrate on screen immediately after your event  Is my sport included? The Athlete Moment will be available for all sports at Milano Cortina 2026. If you’re competing in curling or ice hockey, it will be available from the quarter-finals onwards. For every other sport, it will be available during all sessions.  FIND OUT MORE  Maximising your Games experience  How do I apply?  Fill in the form via the link below to sign up – applications will open in January."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 31,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg32.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
      
      <img class="abs halfScale 32-title" style="top:85px;left:21px;" src="/milanocortina2026/en/static/_content/32-title-1.png"/>
      <img class="abs halfScale 32-title" style="top:138px;left:21px;" src="/milanocortina2026/en/static/_content/32-title-2.png"/>
      <img class="abs halfScale 32-sub" style="top:200px;left:21px;" src="/milanocortina2026/en/static/_content/32-sub-1.png"/>

    `,
      "script": `
        function onPageEnter() {
          pg31Anim = new TimelineMax();
          pg31Anim.staggerFromTo(cOf("32-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .staggerFromTo(cOf("32-sub"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1.4)
        }

        function onPageLeave() {
          pg31Anim.stop();
        }
      `,
      "searchText": "Get Ready Pack: Milano Cortina 2026 | Capture your Olympic experience  Contents  32  Capture your Olympic experience Have a professional headshot taken and get access to photos of yourself competing at the Olympic Games.  Athlete headshots All athletes are required to get a professional headshot taken in the studio in your Olympic Village or competition venue. Your picture will be used for:  There will also be an audio recording during the session to ensure your name is pronounced properly during commentary. The schedules and location will be communicated for each discipline.  • TV graphics • Public scoreboards • Website biographies • Social media  Competition images The Athlete365 app gives you direct access to all professional photos taken of you at Games-time. You will also get access to your headshot and the Samsung Victory Selfie.  Make sure you get your headshot taken at least two days before your first competition.  Maximising your Games experience  All photos on the app are yours to keep and share on social media."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 32,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg33.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>

      <img class="abs halfScale 33-title" style="top:85px;left:21px;" src="/milanocortina2026/en/static/_content/33-title-1.png"/>
      <img class="abs halfScale 33-sub" style="top:149px;left:21px;" src="/milanocortina2026/en/static/_content/33-sub-1.png"/>
      
      <img class="abs halfScale 33-box" style="top:542px;left:18px;" src="/milanocortina2026/en/static/_content/33-box-1.png"/>
      <img class="abs halfScale 33-box" style="top:629px;left:18px;" src="/milanocortina2026/en/static/_content/33-box-2.png"/>
      <img class="abs halfScale 33-box" style="top:715px;left:18px;" src="/milanocortina2026/en/static/_content/33-box-3.png"/>

      <img class="abs halfScale 33-image" style="top:209px;left:228px;" src="/milanocortina2026/en/static/_content/33-image-1.png"/>

      <a href="https://athlete365.org/social-media-verification-mico" target="_blank">
        <img class="abs halfScaleC halfpulse animatedpulse 29-btn" style="top:390px;left:-23px;" src="/milanocortina2026/en/static/_content/33-btn-1.png"/>
      </a>

    `,
      "script": `
        function onPageEnter() {
          pg33Anim = new TimelineMax();
          pg33Anim.fromTo(cOf("33-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("33-sub"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.2)
          .staggerFromTo(cOf("33-box"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1.6)
        }

        function onPageLeave() {
          pg33Anim.stop();
        }
      `,
      "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Social media verification  Get verified on social media Some of the most popular social media platforms are offering verification for athletes competing at Milano Cortina 2026. Having a verified account on social media shows your audience that they are engaging with the real you and helps elevate your personal brand. Athletes at Milano Cortina 2026 will be able to request verification through Athlete365.  find out more  1 2 3  Log in to Athlete365  Fill in the form  Get verified  Maximising your Games experience  33"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 33,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg34.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>

      <img class="abs halfScale 34-title" style="top:85px;left:22px;" src="/milanocortina2026/en/static/_content/34-title-1.png"/>
      <img class="abs halfScale 34-title" style="top:137px;left:21px;" src="/milanocortina2026/en/static/_content/34-title-2.png"/>
      <img class="abs halfScale 34-sub" style="top:200px;left:20px;" src="/milanocortina2026/en/static/_content/34-sub-1.png"/>
      

      <a href="https://athlete365.org/cyber-abuse" target="_blank">
        <img class="abs halfScaleC halfpulse animatedpulse 29-btn" style="top:331px;left:175px;" src="/milanocortina2026/en/static/_content/33-btn-1.png"/>
      </a>

    `,
      "script": `
        function onPageEnter() {
          pg34Anim = new TimelineMax();
          pg34Anim.staggerFromTo(cOf("34-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .fromTo(cOf("34-sub"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.4)
        }

        function onPageLeave() {
          pg34Anim.stop();
        }
      `,
      "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Online abuse protection  Protecting you from abuse on social media A monitoring system powered by artificial intelligence (AI) will help defend you from online abuse on social media during the Games. How does the service work? The system uses AI to identify abusive comments directed at athletes on public-facing accounts in more than 40 languages and flag them for removal. How effective is the service? At Paris 2024, the monitoring system: 	Analysed 2.4m posts covering 20,000 accounts 	Identified 150,000+ posts as potentially abusive 	Verified 10,000+ posts as abusive and flagged for removal Who is covered? All competing athletes are automatically covered. You can opt out at any time. Accredited entourage members are also able to opt in.  Maximising your Games experience  When is the service in place? The service will start on 4 February 2026 and end on 24 February 2026.  Find out more  34"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 34,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg35.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
      
      <img class="abs halfScale 35-title" style="top:85px;left:21px;" src="/milanocortina2026/en/static/_content/35-title-1.png"/>
      <img class="abs halfScale 35-title" style="top:137px;left:21px;" src="/milanocortina2026/en/static/_content/35-title-2.png"/>
      <img class="abs halfScale 35-sub" style="top:200px;left:21px;" src="/milanocortina2026/en/static/_content/35-sub-1.png"/>

      <img class="abs halfScaleC 35-icon" style="top:328px;left:-4px;" src="/milanocortina2026/en/static/_content/35-icon-1.png" />
      <img class="abs halfScaleC 35-icon" style="top:478px;left:-4px;" src="/milanocortina2026/en/static/_content/35-icon-2.png" />
      <img class="abs halfScaleC 35-icon" style="top:627px;left:-4px;" src="/milanocortina2026/en/static/_content/35-icon-3.png" />
      <img class="abs halfScaleC 35-icon" style="top:478px;left:285px;" src="/milanocortina2026/en/static/_content/35-icon-4.png" />
      <img class="abs halfScaleC 35-icon" style="top:627px;left:285px;" src="/milanocortina2026/en/static/_content/35-icon-5.png" />

      <img class="abs halfScale 35-text" style="top:389px;left:130px;" src="/milanocortina2026/en/static/_content/35-text-1.png"/>
      <img class="abs halfScale 35-text" style="top:529px;left:130px;" src="/milanocortina2026/en/static/_content/35-text-2.png"/>
      <img class="abs halfScale 35-text" style="top:669px;left:130px;" src="/milanocortina2026/en/static/_content/35-text-3.png"/>
      <img class="abs halfScale 35-text" style="top:521px;left:419px;" src="/milanocortina2026/en/static/_content/35-text-4.png"/>
      <img class="abs halfScale 35-text" style="top:678px;left:419px;" src="/milanocortina2026/en/static/_content/35-text-5.png"/>

      <a href="http://athlete365.org/download " target="_blank">
        <img class="abs halfScaleC halfpulse animatedpulse 24-btn" style="top:787px;left:-78px;" src="/milanocortina2026/en/static/_content/35-btn-1.png"/>
      </a>

    `,
      "script": `
        function onPageEnter() {
          pg35Anim = new TimelineMax();
          pg35Anim.staggerFromTo(cOf("35-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .fromTo(cOf("35-sub"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.4)
          .staggerFromTo(cOf("35-icon"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.6)
          .staggerFromTo(cOf("35-text"), 0.7, {opacity:0, x: 20}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 0.1, 1.7)
          
        }

        function onPageLeave() {
          pg35Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Athlete365 app  35  Download the Athlete365 app Everything that Athlete365 has to offer, right at your fingertips. Your go-to destination for our practical resources, learning opportunities and exclusive offers, the Athlete365 app is split into five sections:  Home The latest news from Athlete365.  For you Log in to access a personalised feed based on your interests.  Learning Easy access to all of our bespoke educational courses, with insight from experts and Worldwide Olympic Partners.  Download the Athlete365 app now Maximising your Games experience  Games Everything you need to know before, during and after your time at Milano Cortina 2026.  Your network Keep up to date with the global athlete community and meet your representatives."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 35,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg36.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
      
      <img class="abs halfScale 36-title" style="top:85px;left:21px;" src="/milanocortina2026/en/static/_content/36-title-1.png"/>
      <img class="abs halfScale 36-sub" style="top:148px;left:22px;" src="/milanocortina2026/en/static/_content/36-sub-1.png"/>

      <a href="https://www.olympics.com/athlete365/learning" target="_blank">
        <img class="abs halfScaleC halfpulse animatedpulse 36-btn" style="top:482px;left:-93px;" src="/milanocortina2026/en/static/_content/36-btn-1.png"/>
      </a>

      `,
      "script": `
        function onPageEnter() {
          pg36Anim = new TimelineMax();
          pg36Anim.staggerFromTo(cOf("36-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .fromTo(cOf("36-sub"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.2)
        }

        function onPageLeave() {
          pg36Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Athlete365 Learning  Athlete365 Learning Empower yourself on and off the field of play with new skills, knowledge and expert advice. Athlete365 Learning is a bespoke educational platform designed for athletes and their entourage, with insight from experts and Worldwide Olympic Partners to help you on your journey to the Olympic Games. Our courses cover a wide range of important topics, from maximising your performance, to improving your mental strength and building a winning personal brand. Upon completion of each course, you will receive an official IOC Certificate.  Start your Athlete365 Learning journey  Maximising your Games experience  36"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 36,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg37.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
      
      <img class="abs halfScale 37-title" style="top:111px;left:20px;" src="/milanocortina2026/en/static/_content/37-title-1.png"/>
      <img class="abs halfScale 37-sub" style="top:222px;left:20px;" src="/milanocortina2026/en/static/_content/37-sub-1.png"/>

    `,
      "script": `
        function onPageEnter() {
          pg37Anim = new TimelineMax();
          pg37Anim.staggerFromTo(cOf("37-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .fromTo(cOf("37-sub"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.2)
        }

        function onPageLeave() {
          pg37Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | PinQuest  37  Start your PinQuest journey today!  Win limited-edition Milano Cortina 2026 souvenirs! PinQuest is a digital game that invites you to test your Olympic knowledge, challenge other athletes and athletes’ entourage members, interact with IOC Athletes’ Commission members – and win an exclusive Milano Cortina 2026 pin collection (and more)!  How do I play?  What can I win?  Download the PinQuest app from your store and sign in using your Olympic ID.  If you accumulate 10,000 points, you will unlock an exclusive collection of Milano Cortina 2026 pins. There are also several other special prizes available, including Allianz's special pin!  When you're up and running, simply explore the virtual 3D map, answer quiz questions and challenge other players.  Maximising your Games experience  How do I collect my prizes? Simply head to the PinQuest desk at Athlete365 House to claim."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 37,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg38.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
      
      <img class="abs halfScale 38-title" style="top:85px;left:21px;" src="/milanocortina2026/en/static/_content/38-title-1.png"/>
      <img class="abs halfScale 38-sub" style="top:148px;left:22px;" src="/milanocortina2026/en/static/_content/38-sub-1.png"/>

      <a href="https://www.olympics.com/athlete365/news/milano-cortina2026/milano-cortina-2026-ticket-information-for-athletes" target="_blank">
        <img class="abs halfScaleC halfpulse animatedpulse 38-btn" style="top:772px;left:-23px;" src="/milanocortina2026/en/static/_content/38-btn-1.png"/>
      </a>

    `,
      "script": `
        function onPageEnter() {
          pg38Anim = new TimelineMax();
          pg38Anim.staggerFromTo(cOf("38-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .fromTo(cOf("38-sub"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.2)
        }

        function onPageLeave() {
          pg38Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | How to access tickets  How to access tickets Want to secure tickets for yourself and your loved ones? Here are your ticketing options. Athletes’ Friends & Family Ticketing Programme Purchase two tickets per session in which you are competing. • Preliminary round tickets available in early February • Intermediate round tickets available between rounds • Use your accreditation number to purchase on dedicated web shop  Different Discipline Athletes Programme Support your fellow athletes free of charge. • For outdoor venues, you can enter using only your accreditation • For indoor venues, you can request one ticket per day on a first-come first-served basis, and must bring both your ticket and accreditation • Dedicated web shop open in early February  FIND OUT MORE  Maximising your Games experience  38"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 38,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg39.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
      
      <img class="abs halfScale 39-title" style="top:85px;left:20px;" src="/milanocortina2026/en/static/_content/39-title-1.png"/>
      <img class="abs halfScale 39-sub" style="top:148px;left:20px;" src="/milanocortina2026/en/static/_content/39-sub-1.png"/>

    `,
      "script": `
        function onPageEnter() {
          pg39Anim = new TimelineMax();
          pg39Anim.staggerFromTo(cOf("39-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .fromTo(cOf("39-sub"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.2)
        }

        function onPageLeave() {
          pg39Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Opening Ceremony  39  Opening Ceremony A new vision for the Opening Ceremony will be in place at Milano Cortina 2026. Taking part in the Opening Ceremony is one of the most memorable moments of the Olympic Games.  Milano Cortina 2026 will take place across four locations: Milan, Cortina, Livigno and Predazzo.  Dedicated transport will be provided within each cluster, taking you from your Village to your Opening Ceremony.  To ensure the maximum number of athletes get to enjoy this once-in-a-lifetime experience, the Opening Ceremony of  If you want to take part in the Opening Ceremony, you will parade in the cluster where you are competing.  Contact your NOC, e.g. your Chef de Mission, for more information.  Maximising your Games experience"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 39,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg40.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
      
      <img class="abs halfScale 40-title" style="top:202px;left:20px;" src="/milanocortina2026/en/static/_content/40-title-1.png"/>
      <img class="abs halfScale 40-sub" style="top:265px;left:20px;" src="/milanocortina2026/en/static/_content/40-sub-1.png"/>

    `,
      "script": `
        function onPageEnter() {
          pg40Anim = new TimelineMax();
          pg40Anim.staggerFromTo(cOf("40-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .fromTo(cOf("40-sub"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.2)
        }

        function onPageLeave() {
          pg40Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Get Set - Train Smarter  Google Play Store  App Store  Get Set – Train Smarter The Get Set – Train Smarter app helps incorporate injury prevention into your exercise routines using scientifically proven methods – allowing you to perform at your best and stay injury free when you need it the most. Prevent injuries with effective and evidence-based workout routines Exercises included for 55 sports – including 15 winter disciplines Focus on the body part of your choice  Get Set is available in 11 languages: English, French, Spanish, Russian, German, Norwegian, Chinese, Korean, Finnish, Italian and Slovenian.  Maximising your Games experience  40"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 40,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg41.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>

      <img class="abs halfScale 41-title" style="top:107px;left:231px;" src="/milanocortina2026/en/static/_content/41-title-1.png"/>
      <img class="abs halfScale 41-title" style="top:177px;left:248px;" src="/milanocortina2026/en/static/_content/41-title-2.png"/>
      <img class="abs halfScale 41-title" style="top:580px;left:103px;" src="/milanocortina2026/en/static/_content/41-sub-1.png"/>

      <div class="addContentLink" onclick="Publish.goToPage(42);" style="top:633px; left:111px; width:196px; height:38px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(43);" style="top:685px; left:111px; width:196px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(44);" style="top:723px; left:111px; width:196px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(45);" style="top:760px; left:111px; width:196px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(46);" style="top:799px; left:111px; width:196px; height:22px;"></div>

      <div class="addContentLink" onclick="Publish.goToPage(47);" style="top:633px; left:318px; width:196px; height:38px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(48);" style="top:685px; left:318px; width:196px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(49);" style="top:723px; left:318px; width:196px; height:22px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(50);" style="top:760px; left:318px; width:196px; height:22px;"></div>

      `,
      "script": `
        function onPageEnter() {
          pg41Anim = new TimelineMax();
          pg41Anim.staggerFromTo(cOf("41-title"), 0.8, {opacity:0, x: -40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1);
          setTimeout(function(){
            addContentLinks();
          },2000)
        }

        function onPageLeave() {
          pg41Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Need to know  41  NEED TO KNOW  Essential information for a stress-free Games. 42 Getting to your  47 P revention of  43 How to seek help  48 Anti-doping  44 Social media guidelines  49 Sustainability  45 Athlete Expression  50 Departures  competition venue  46 Commercial opportunities NEED TO KNOW  competition manipulation"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 41,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg42.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
      
      <img class="abs halfScale 42-title" style="top:85px;left:21px;" src="/milanocortina2026/en/static/_content/42-title-1.png"/>
      <img class="abs halfScale 42-title" style="top:137px;left:21px;" src="/milanocortina2026/en/static/_content/42-title-2.png"/>
      <img class="abs halfScale 42-sub" style="top:200px;left:20px;" src="/milanocortina2026/en/static/_content/42-sub-1.png"/>

    `,
      "script": `
        function onPageEnter() {
          pg42Anim = new TimelineMax();
          pg42Anim.staggerFromTo(cOf("42-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .fromTo(cOf("42-sub"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.4)
        }

        function onPageLeave() {
          pg42Anim.stop();
        }
      `,
      "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Getting to your competition venue  42  Getting to your competition venue Average travel times between each Olympic Village and competition venue.  MILAN Venue  Distance from Village (KM)  Avg. Travel Time by TA  Avg. Travel Time by TP  Milano Santagiulia Ice Hockey Arena  7.4  20  45  Milano Rho Ice Hockey Arena  29.1  45  60  Milano Ice Skating Arena  8  30  45  Milano Speed Skating Stadium  29.1  45  60  Distance from Village (KM)  Avg. Travel Time by TA  Avg. Travel Time by TP  7  25  30  CORTINA Venue Tofane Alpine Skiing Centre Cortina Sliding Centre  5  15  15  Cortina Curling Olympic Stadium  6  15  15  Distance from Village (KM)  Avg. Travel Time by TA  Avg. Travel Time by TP  Predazzo Ski Jumping Stadium  3  11  35  Tesero Cross-Country Skiing Stadium  8  16  40  Distance from Village (KM)  Avg. Travel Time by TA  Avg. Travel Time by TP  Livigno Snow Park  1  7  8  Livigno Aerials & Moguls Park  3  13  16  Distance from Village (KM)  Avg. Travel Time by TA  Avg. Travel Time by TP  1  7  8  Distance from Village (KM)  Avg. Travel Time by TA  Avg. Travel Time by TP  17  25  30  PREDAZZO Venue  LIVIGNO Venue  BORMIO Venue Stelvio Ski Centre  ANTERSELVA Venue Anterselva Biathlon Arena  NEED TO KNOW  Travel Time: Minutes TA: Transport for Athletes TP: Public transport"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 42,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg43.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
      
      <img class="abs halfScale 43-title" style="top:165px;left:21px;" src="/milanocortina2026/en/static/_content/43-title-1.png"/>
      <img class="abs halfScale 43-title" style="top:216px;left:21px;" src="/milanocortina2026/en/static/_content/43-title-2.png"/>
      <img class="abs halfScale 43-sub" style="top:279px;left:22px;" src="/milanocortina2026/en/static/_content/43-sub-1.png"/>

      <a href="https://www.olympics.com/athlete365/articles/safesport/how-to-seek-help-at-milano-cortina-2026" target="_blank">
        <img class="abs halfScaleC halfpulse animatedpulse 43-btn" style="top:385px;left:-23px;" src="/milanocortina2026/en/static/_content/43-btn-1.png"/>
      </a>
      <a href="https://www.olympics.com/athlete365/offers/mentally-fit/access-the-mentally-fit-helpline" target="_blank">
        <img class="abs halfScaleC halfpulse animatedpulse 43-btn" style="top:400px;left:273px;" src="/milanocortina2026/en/static/_content/43-btn-2.png"/>
      </a>
      <a href="https://ioc.integrityline.org/" target="_blank">
        <img class="abs halfScaleC halfpulse animatedpulse 43-btn" style="top:537px;left:275px;" src="/milanocortina2026/en/static/_content/43-btn-3.png"/>
      </a>

      <div class="addContentLink" style="top:647px;left:367px;width:189px;height:19px">
        <a href="mailto:safeguardingofficer@olympic.org"></a>
      </div>

      <div class="addContentLink" style="top:784px;left:421px;width:151px;height:12px">
        <a href="mailto:safeguardingofficer@olympic.org"></a>
      </div>

    `,
      "script": `
        function onPageEnter() {
          pg43Anim = new TimelineMax();
          pg43Anim.staggerFromTo(cOf("43-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .fromTo(cOf("43-sub"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.4);
        }

        function onPageLeave() {
          pg43Anim.stop();
        }
      `,
      "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | How to seek help  How to seek help Whether you find yourself struggling or have seen something that doesn't feel right, here's how to find support. No pressure, no judgement – just someone who’s got your back. FIND OUT MORE  43  Athlete365 Mind Zone: Visit the Mind Zone in your Olympic Village* for well-being and safeguarding support from qualified IOC Safeguarding Officers.  The Mentally Fit helpline: A confidential 24-hour counselling service with professional support in 70 languages. Available to all Olympians at Milano Cortina 2026 for four years.  CONTACT THE MENTALLY FIT HELPLINE  IOC Integrity Hotline: File an online report relating to harassment/ abuse or competition manipulation – you can choose to remain anonymous if you wish.  CONTACT THE IOC INTEGRITY HOTLINE  Email: Reach out to the IOC Safeguarding Officers at safeguardingofficer@olympic.org.  EMERGENCY SERVICES: In case of an emergency, call 112 for the police, ambulance or fire brigade. *For safeguarding support in Bormio, please contact safeguardingofficer@olympic.org. For mental health support, visit the polyclinic.  NEED TO KNOW"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 43,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg44.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
      
      <img class="abs halfScale 44-title" style="top:85px;left:21px;" src="/milanocortina2026/en/static/_content/44-title-1.png"/>
      <img class="abs halfScale 44-sub" style="top:148px;left:22px;" src="/milanocortina2026/en/static/_content/44-sub-1.png"/>

      <a href="https://www.olympics.com/athlete365/articles/smg/milano-cortina-2026-social-media-guidelines" target="_blank">
        <img class="abs halfScaleC halfpulse animatedpulse 44-btn" style="top:765px;left:-23px;" src="/milanocortina2026/en/static/_content/44-btn-1.png"/>
      </a>

    `,
      "script": `
        function onPageEnter() {
          pg44Anim = new TimelineMax();
          pg44Anim.staggerFromTo(cOf("44-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .fromTo(cOf("44-sub"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.2)
        }

        function onPageLeave() {
          pg44Anim.stop();
        }
      `,
      "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Social media guidelines  Social media guidelines Milano Cortina 2026 offers more opportunities to engage with your followers than any previous Olympic Winter Games.  You are encouraged to share your Olympic experience with your friends, family and supporters. The IOC social and digital media guidelines set out exactly where you are able to capture content and what you can share on your social media accounts or other channels. You will need to follow the guidelines from 30 January to 24 February. The rules on prohibited content still apply after this period.  Why do these guidelines exist? The guidelines allow you to share your experience at the Games while protecting the rights of IOC Media Rights-Holders. Access the guidelines and FAQs for athletes and other accredited individuals:  FIND OUT MORE  NEED TO KNOW  44"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 44,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg45.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
      
      <img class="abs halfScale 45-title" style="top:447px;left:21px;" src="/milanocortina2026/en/static/_content/45-title-1.png"/>
      <img class="abs halfScale 45-title" style="top:498px;left:21px;" src="/milanocortina2026/en/static/_content/45-title-2.png"/>
      <img class="abs halfScale 45-sub" style="top:562px;left:21px;" src="/milanocortina2026/en/static/_content/45-sub-1.png"/>

      <a href="https://www.olympics.com/athlete365/articles/athlete-expression/athlete-expression-guidelines-for-milano-cortina-2026" target="_blank">
        <img class="abs halfScaleC halfpulse animatedpulse 45-btn" style="top:771px;left:-57px;" src="/milanocortina2026/en/static/_content/45-btn-1.png"/>
      </a>

    `,
      "script": `
        function onPageEnter() {
          pg45Anim = new TimelineMax();
          pg45Anim.staggerFromTo(cOf("45-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .fromTo(cOf("45-sub"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.4)
        }

        function onPageLeave() {
          pg45Anim.stop();
        }
      `,
      "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Athlete Expression  Athlete Expression The Athlete Expression guidelines outline the opportunities you have to express your views while respecting others. • Sport at the Olympic Games is neutral and must be separate from political, religious or any other type of interference. • The focus on the field of play during competitions and official ceremonies must be on celebrating athletes' performances. • The Olympic Village must provide respectful conditions for all athletes to live together.  Read the guidelines in full  NEED TO KNOW  45"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 45,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg46.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
      
      <img class="abs halfScale 46-title" style="top:422px;left:21px;" src="/milanocortina2026/en/static/_content/46-title-1.png"/>
      <img class="abs halfScale 46-sub" style="top:486px;left:22px;" src="/milanocortina2026/en/static/_content/46-sub-1.png"/>

      <a href="https://www.olympics.com/athlete365/articles/rule-40/rule-40-resources-for-milano-cortina-2026" target="_blank">
        <img class="abs halfScaleC halfpulse animatedpulse 46-btn" style="top:689px;left:-23px;" src="/milanocortina2026/en/static/_content/46-btn-1.png"/>
      </a>

    `,
      "script": `
        function onPageEnter() {
          pg46Anim = new TimelineMax();
          pg46Anim.staggerFromTo(cOf("46-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .fromTo(cOf("46-sub"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.2)
        }

        function onPageLeave() {
          pg46Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Commercial opportunities  commercial opportunities How to engage in and benefit from commercial activities during the Games. • As athletes, you are able to generate income through personal sponsorships with well-planned advertising during Milano Cortina 2026, as long as you follow the r equirements of the Rule 40 framework. • By doing this, you help the Olympic Movement maintain its solidarity funding model, ensuring athletes from around the world are able to participate in the Games. • Read the Key Principles, Illustrative Guidance and FAQs now to understand your rights and responsibilities.  Find out more  NEED TO KNOW  46"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 46,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg47.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
      
      <img class="abs halfScale 47-title" style="top:135px;left:21px;" src="/milanocortina2026/en/static/_content/47-title-1.png"/>
      <img class="abs halfScale 47-title" style="top:187px;left:21px;" src="/milanocortina2026/en/static/_content/47-title-2.png"/>
      <img class="abs halfScale 47-title" style="top:239px;left:21px;" src="/milanocortina2026/en/static/_content/47-title-3.png"/>
      <img class="abs halfScale 47-sub" style="top:306px;left:22px;" src="/milanocortina2026/en/static/_content/47-sub-1.png"/>

      <a href="https://www.olympics.com/athlete365/topics/believeinsport?nxtPpath=believeinsport " target="_blank">
        <img class="abs halfScaleC halfpulse animatedpulse 47-btn" style="top:503px;left:-17px;" src="/milanocortina2026/en/static/_content/47-btn-1.png"/>
      </a>
      <a href="https://ioc.integrityline.org/ " target="_blank">
        <img class="abs halfScaleC halfpulse animatedpulse 47-btn" style="top:635px;left:321px;" src="/milanocortina2026/en/static/_content/47-btn-2.png"/>
      </a>

    `,
      "script": `
        function onPageEnter() {
          pg47Anim = new TimelineMax();
          pg47Anim.staggerFromTo(cOf("47-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .fromTo(cOf("47-sub"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.6)
        }

        function onPageLeave() {
          pg47Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Prevention of competition manipulation  Prevention of Competition Manipulation What’s the point of sport if the result is fixed in advance? Make the right decision and join the fight against competition manipulation. Competition manipulation happens when athletes intentionally underperform or lose on purpose. It’s also when officials intentionally make wrong decisions affecting the competition. This may be for a financial, sporting or other advantage.  47  There are four key rules to follow as athletes: We will not fix the competition and always do our best.  We will not bet on our own sport or any event at the Olympic Games.  We will not share information about health issues or sport tactics.  We will speak up if we witness or suspect competition manipulation.  Learn more Suspicious activity should be reported through the IOC Integrity Hotline. All matters are dealt with professionally, with full confidentiality and anonymity.  IOC Integrity Hotline  NEED TO KNOW"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 47,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg48.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
      
      <img class="abs halfScale 48-title" style="top:85px;left:21px;" src="/milanocortina2026/en/static/_content/48-title-1.png"/>
      <img class="abs halfScale 48-sub" style="top:149px;left:21px;" src="/milanocortina2026/en/static/_content/48-sub-1.png"/>

      <a href="https://img.olympics.com/images/image/private/w_auto/primary/mztq85yvowvi4ciehdw7" target="_blank">
        <img class="abs halfScaleC halfpulse animatedpulse 48-btn" style="top:557px;left:-46px;" src="/milanocortina2026/en/static/_content/48-btn-1.png"/>
      </a>
      <a href="https://www.olympics.com/athlete365/news/antidoping/key-anti-doping-resources-available-for-milano-cortina-2026" target="_blank">
        <img class="abs halfScaleC halfpulse animatedpulse 48-btn" style="top:618px;left:-14px;" src="/milanocortina2026/en/static/_content/48-btn-2.png"/>
      </a>

    `,
      "script": `
        function onPageEnter() {
          pg48Anim = new TimelineMax();
          pg48Anim.staggerFromTo(cOf("48-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .fromTo(cOf("48-sub"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.2)
        }

        function onPageLeave() {
          pg48Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "Contents  Get Ready Pack: Milano Cortina 2026 | Anti-doping  Anti-doping rules All athletes competing at the Olympic Games – and their entourage members – must comply with the IOC's anti-doping policies. As athletes and entourage members, you are solely responsible for ensuring that you comply with the anti-doping rules at the Olympic Games. To protect yourself and your place at the Games, it is essential that you understand the rules that are in place. Ahead of Milano Cortina 2026, the IOC has confirmed the anti-doping rules and system for the upcoming Olympic Winter Games.  Full anti-doping rules  Resources  NEED TO KNOW  48"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 48,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg49.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
        <img class="abs halfScale 49-title" style="top:85px;left:21px;" src="/milanocortina2026/en/static/_content/49-title-1.png"/>
        <img class="abs halfScale 49-sub" style="top:147px;left:21px;" src="/milanocortina2026/en/static/_content/49-sub-1.png"/>

        <img class="abs halfScaleC 49-sub-2" style="top:243px;left:-32px;" src="/milanocortina2026/en/static/_content/49-sub-2.png"/>
        <img class="abs halfScaleC 49-sub-2" style="top:243px;left:128px;" src="/milanocortina2026/en/static/_content/49-sub-3.png"/>
        <img class="abs halfScaleC 49-sub-2" style="top:243px;left:372px;" src="/milanocortina2026/en/static/_content/49-sub-4.png"/>

        <img class="abs halfScaleC 49-col-1" style="top:318px;left:-6px;" src="/milanocortina2026/en/static/_content/49-icon-1.png"/>
        <img class="abs halfScaleC 49-col-1" style="top:349px;left:49px;" src="/milanocortina2026/en/static/_content/49-text-1.png"/>
        <img class="abs halfScaleC 49-col-1" style="top:360px;left:-25px;" src="/milanocortina2026/en/static/_content/49-line-1.png"/>
        <img class="abs halfScaleC 49-col-1" style="top:449px;left:109px;" src="/milanocortina2026/en/static/_content/49-icon-2.png"/>
        <img class="abs halfScaleC 49-col-1" style="top:480px;left:27px;" src="/milanocortina2026/en/static/_content/49-text-2.png"/>
        <img class="abs halfScaleC 49-col-1" style="top:508px;left:-20px;" src="/milanocortina2026/en/static/_content/49-line-2.png"/>
        <img class="abs halfScaleC 49-col-1" style="top:561px;left:-6px;" src="/milanocortina2026/en/static/_content/49-icon-3.png"/>
        <img class="abs halfScaleC 49-col-1" style="top:579px;left:44px;" src="/milanocortina2026/en/static/_content/49-text-3.png"/>

        <img class="abs halfScale 49-box" style="top:685px;left:-260px;" src="/milanocortina2026/en/static/_content/49-box.png"/>
        <img class="abs halfScaleC 49-col-1-pull-out-box" style="top:673px;left:2px;" src="/milanocortina2026/en/static/_content/49-icon-4.png"/>
        <img class="abs halfScaleC 49-col-1-pull-out-box" style="top:720px;left:-32px;" src="/milanocortina2026/en/static/_content/49-text-4.png"/>
        <a href="https://stillmed.olympics.com/media/Documents/Beyond-the-Games/Sustainability/Essentials/How-to-be-a-sustainable-champion-guide.pdf" target="_blank">
          <img class="abs halfScaleC 49-col-1-pull-out-box" style="top:769px;left:-23px;" src="/milanocortina2026/en/static/_content/49-btn-1.png"/>
        </a>

        <img class="abs halfScaleC 49-col-2" style="top:278px;left:141px;" src="/milanocortina2026/en/static/_content/49-piechart.png"/>
        <img class="abs halfScaleC 49-col-2" style="top:384px;left:167px;" src="/milanocortina2026/en/static/_content/49-text-5.png"/>
        <img class="abs halfScaleC 49-col-2" style="top:292px;left:315px;" src="/milanocortina2026/en/static/_content/49-line-3.png"/>
        <img class="abs halfScaleC 49-col-2" style="top:439px;left:277px;" src="/milanocortina2026/en/static/_content/49-text-6.png"/>
        <img class="abs halfScaleC 49-col-2" style="top:384px;left:202px;" src="/milanocortina2026/en/static/_content/49-icon-5.png"/>
        <img class="abs halfScaleC 49-col-2" style="top:422px;left:203px;" src="/milanocortina2026/en/static/_content/49-line-4.png"/>
        <img class="abs halfScaleC 49-col-2" style="top:491px;left:160px;" src="/milanocortina2026/en/static/_content/49-text-7.png"/>
        <img class="abs halfScaleC 49-col-2" style="top:458px;left:311px;" src="/milanocortina2026/en/static/_content/49-icon-6.png"/>
        <img class="abs halfScaleC 49-col-2" style="top:487px;left:388px;" src="/milanocortina2026/en/static/_content/49-line-5.png"/>
        <img class="abs halfScaleC 49-col-2" style="top:551px;left:274px;" src="/milanocortina2026/en/static/_content/49-text-8.png"/>
        <img class="abs halfScaleC 49-col-2" style="top:518px;left:225px;" src="/milanocortina2026/en/static/_content/49-icon-7.png"/>
        <img class="abs halfScaleC 49-col-2" style="top:544px;left:229px;" src="/milanocortina2026/en/static/_content/49-line-6.png"/>
        <img class="abs halfScaleC 49-col-2" style="top:613px;left:200px;" src="/milanocortina2026/en/static/_content/49-text-9.png"/>
        <img class="abs halfScaleC 49-col-2" style="top:653px;left:182px;" src="/milanocortina2026/en/static/_content/49-text-10.png"/>
        <img class="abs halfScaleC 49-col-2" style="top:593px;left:297px;" src="/milanocortina2026/en/static/_content/49-icon-8.png"/>
        <img class="abs halfScaleC 49-col-2" style="top:631px;left:382px;" src="/milanocortina2026/en/static/_content/49-line-7.png"/>
        <img class="abs halfScaleC 49-col-2" style="top:691px;left:286px;" src="/milanocortina2026/en/static/_content/49-text-11.png"/>
        <img class="abs halfScaleC 49-col-2" style="top:673px;left:234px;" src="/milanocortina2026/en/static/_content/49-icon-9.png"/>
        <img class="abs halfScaleC 49-col-2" style="top:698px;left:198px;" src="/milanocortina2026/en/static/_content/49-line-8.png"/>
        <img class="abs halfScaleC 49-col-2" style="top:772px;left:178px;" src="/milanocortina2026/en/static/_content/49-text-12.png"/>
        <img class="abs halfScaleC 49-col-2" style="top:742px;left:304px;" src="/milanocortina2026/en/static/_content/49-icon-10.png"/>
        <h1 id="49-no" class="abs olympicHeadlineReg 49-no" style="top:341px;left:229px; font-size: 2.35em; font-weight: 300; color: #FF9196; padding: 0px; margin: 0px;"  data-number='{"to": 85, "append": "%"}' ></h1>
        <h1 id="49-no" class="abs olympicHeadlineReg 49-no" style="top:412px;left:336px; font-size: 2.35em; font-weight: 300; color: #FF9196; padding: 0px; margin: 0px;"  data-number='{"to": 100, "append": "%"}' ></h1>
        <h1 id="49-no" class="abs olympicHeadlineReg 49-no" style="top:624px;left:217px; font-size: 2.35em; font-weight: 300; color: #FF9196; padding: 0px; margin: 0px;"  data-number='{"to": 20000, "comma": true}' ></h1>

        <img class="abs halfScaleC 49-col-3" style="top:349px;left:451px;" src="/milanocortina2026/en/static/_content/49-text-13.png"/>
        <img class="abs halfScaleC 49-col-3" style="top:318px;left:398px;" src="/milanocortina2026/en/static/_content/49-icon-11.png"/>
        <img class="abs halfScaleC 49-col-3" style="top:380px;left:386px;" src="/milanocortina2026/en/static/_content/49-line-9.png"/>
        <img class="abs halfScaleC 49-col-3" style="top:439px;left:399px;" src="/milanocortina2026/en/static/_content/49-text-14.png"/>
        <img class="abs halfScaleC 49-col-3" style="top:420px;left:521px;" src="/milanocortina2026/en/static/_content/49-icon-12.png"/>
        <img class="abs halfScaleC 49-col-3" style="top:488px;left:395px;" src="/milanocortina2026/en/static/_content/49-line-10.png"/>
        <img class="abs halfScaleC 49-col-3" style="top:531px;left:441px;" src="/milanocortina2026/en/static/_content/49-text-15.png"/>
        <img class="abs halfScaleC 49-col-3" style="top:514px;left:403px;" src="/milanocortina2026/en/static/_content/49-icon-13.png"/>
        <img class="abs halfScaleC 49-col-3" style="top:578px;left:392px;" src="/milanocortina2026/en/static/_content/49-line-11.png"/>
        <img class="abs halfScaleC 49-col-3" style="top:628px;left:438px;" src="/milanocortina2026/en/static/_content/49-text-16.png"/>
        <img class="abs halfScaleC 49-col-3" style="top:609px;left:522px;" src="/milanocortina2026/en/static/_content/49-icon-14.png"/>
        <img class="abs halfScaleC 49-col-3" style="top:677px;left:392px;" src="/milanocortina2026/en/static/_content/49-line-12.png"/>
        <img class="abs halfScaleC 49-col-3" style="top:723px;left:445px;" src="/milanocortina2026/en/static/_content/49-text-17.png"/>
        <img class="abs halfScaleC 49-col-3" style="top:705px;left:404px;" src="/milanocortina2026/en/static/_content/49-icon-15.png"/>
    `,
      "script": `
        function onPageEnter() {
          pg49Anim = new TimelineMax();
          pg49Anim.staggerFromTo(cOf("49-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .fromTo(cOf("49-sub"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.2)
          .staggerFromTo(cOf("49-sub-2"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.5)
          .staggerFromTo(cOf("49-col-1"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.6)
          .staggerFromTo(cOf("49-col-2"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.7)
          .staggerFromTo(cOf("49-col-3"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.8)
          .fromTo(cOf("49-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("49-no")[0])}}, 1.8)
          .fromTo(cOf("49-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("49-no")[1])}}, 2)
          .fromTo(cOf("49-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("49-no")[2])}}, 3)
          .fromTo(cOf("49-box"), 0.8, {opacity:0, x: -120}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 2.3)
          .staggerFromTo(cOf("49-col-1-pull-out-box"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 2.5)
          
        }

        function onPageLeave() {
          pg49Anim.stop();
          removeContentLinks();
          resetNumbers("49-no");
        }
      `,
      "searchText": "Get Ready Pack: Milano Cortina 2026 | Sustainability  Contents  49  Sustainability at the Games Milano Cortina 2026 has set out a number of objectives to make the Games more sustainable. As athletes, you have a key role to play.  Sustainability objectives:  Minimise the carbon footprint  How will Milano Cortina 2026 achieve this?  85%  How can athletes contribute?  Avoid single-use plastic items  existing or temporary venues  100%  renewable energy at venues Protect natural ecosystems  Transportation plan favouring trains and buses  Low carbon menus and local products Reduce waste and promote circular economy  20,000  Drink tap water instead of bottled water Biodiversity conservation and restoration plans  Learn how you can be a sustainable champion with our guide  NEED TO KNOW  Opt for low carbon and more sustainable food options  Reuse of  equipment items from Paris 2024  Find out more  Follow waste-sorting instructions to maximise recycling  More energy-efficient snow-making system  Keep it simple and refuse any unnecessary goods"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 49,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg50.jpg",
      "zoom": null,
      "content": `

      <div class="abs pointer" onclick="Publish.goToPage(2);" style="top:9px; left:16px; width:51px; height:16px;"></div>
      
      <img class="abs halfScale 50-title" style="top:85px;left:21px;" src="/milanocortina2026/en/static/_content/50-title-1.png"/>
      <img class="abs halfScale 50-sub" style="top:147px;left:21px;" src="/milanocortina2026/en/static/_content/50-sub-1.png"/>

      <img class="abs halfScaleC 50-textbubble" style="top:76px;left:-108px;" src="/milanocortina2026/en/static/_content/50-textbubble.png"/>

      <img class="abs halfScaleC 50-arrow" style="top:328px;left:101px;" src="/milanocortina2026/en/static/_content/50-arrow-1.png"/>
      <img class="abs halfScaleC 50-arrow" style="top:396px;left:82px;" src="/milanocortina2026/en/static/_content/50-arrow-2.png"/>
      <img class="abs halfScaleC 50-arrow" style="top:253px;left:128px;" src="/milanocortina2026/en/static/_content/50-arrow-3.png"/>
      <img class="abs halfScaleC 50-arrow" style="top:289px;left:111px;" src="/milanocortina2026/en/static/_content/50-arrow-4.png"/>
      <img class="abs halfScaleC 50-arrow" style="top:150px;left:129px;" src="/milanocortina2026/en/static/_content/50-arrow-5.png"/>

      <img class="abs halfScaleC 50-yesno" style="top:496px;left:75px;" src="/milanocortina2026/en/static/_content/50-yes.png"/>
      <img class="abs halfScaleC 50-yesno" style="top:450px;left:143px;" src="/milanocortina2026/en/static/_content/50-yes.png"/>
      <img class="abs halfScaleC 50-yesno" style="top:492px;left:341px;" src="/milanocortina2026/en/static/_content/50-yes.png"/>
      <img class="abs halfScaleC 50-yesno" style="top:316px;left:377px;" src="/milanocortina2026/en/static/_content/50-yes.png"/>
      <img class="abs halfScaleC 50-yesno" style="top:184px;left:343px;" src="/milanocortina2026/en/static/_content/50-no.png"/>

      <img class="abs halfScaleC 50-text" style="top:607px;left:-80px;" src="/milanocortina2026/en/static/_content/50-text-1.png"/>
      <img class="abs halfScaleC 50-text" style="top:436px;left:102px;" src="/milanocortina2026/en/static/_content/50-text-2.png"/>
      <img class="abs halfScaleC 50-text" style="top:615px;left:187px;" src="/milanocortina2026/en/static/_content/50-text-3.png"/>
      <img class="abs halfScaleC 50-text" style="top:457px;left:350px;" src="/milanocortina2026/en/static/_content/50-text-4.png"/>
      <img class="abs halfScaleC 50-text" style="top:212px;left:345px;" src="/milanocortina2026/en/static/_content/50-text-5.png"/>

      <img class="abs halfScaleC 50-icon" style="top:609px;left:64px;" src="/milanocortina2026/en/static/_content/50-icon-1.png"/>
      <img class="abs halfScaleC 50-icon" style="top:442px;left:216px;" src="/milanocortina2026/en/static/_content/50-icon-2.png"/>
      <img class="abs halfScaleC 50-icon" style="top:608px;left:330px;" src="/milanocortina2026/en/static/_content/50-icon-3.png"/>
      <img class="abs halfScaleC 50-icon" style="top:440px;left:455px;" src="/milanocortina2026/en/static/_content/50-icon-4.png"/>
      <img class="abs halfScaleC 50-icon" style="top:170px;left:450px;" src="/milanocortina2026/en/static/_content/50-icon-5.png"/>

      
      <img class="abs halfScale 50-textbox" style="top:639px;left:482px;" src="/milanocortina2026/en/static/_content/50-textbox.png"/>
      <img class="abs halfScale 50-bottom-bar-1" style="top:832px;left:-35px;" src="/milanocortina2026/en/static/_content/50-bottom-bar-1.png" />
      

    `,
      "script": `
        function onPageEnter() {
          pg50Anim = new TimelineMax();
          pg50Anim.staggerFromTo(cOf("50-title"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .fromTo(cOf("50-sub"), 0.8, {opacity:0, x: 40}, {opacity: 1, x: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 1.2)
          .fromTo(cOf("50-textbubble"), 0.8, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.4)
          .staggerFromTo(cOf("50-arrow"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.5)
          .staggerFromTo(cOf("50-yesno"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.6)
          .staggerFromTo(cOf("50-icon"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.7)
          .staggerFromTo(cOf("50-text"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.8)
          .fromTo(cOf("50-textbox"), 0.8, {opacity:0, y: 200}, {opacity: 1, y: 0, ease: Power2.easeOut, oncomplete: addContentLinks}, 2.2)
        }

        function onPageLeave() {
          pg50Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "Get Ready Pack: Milano Cortina 2026 | Departures  Contents  50  Heading home What to expect when departing the Games.  NO Departure services will be organised by your NOC for return to your port of exit.  ARE YOU ATTENDING THE CLOSING CEREMONY?  yes  yes yes  Option 1 Leave straight to the airport: Shuttle buses will take you to Verona Porta Nuova train station, then you will get the train to Milano Malpensa or Venezia Marco Polo Airport. If you are leaving the next day, dedicated waiting areas will be in place at the airport.  NEED TO KNOW  yes  Option 2  Option 4  Leave via the Milan Village:  drive yourself:  If you have a bed in the Milan Village, you can return for the night. If you don’t have a bed but would like to wait for your onward travel in Milan, there will be dedicated waiting areas in place in the Village.  Park and ride services will be provided for athletes who wish to drive to the Closing Ceremony.  Option 3 Return to your Village: If you want to return to your Village, dedicated buses will be in place. Departure services will then be organised by your NOC for return to your port of exit.  Please speak to your NOC, e.g. your Chef de Mission, for more information."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 50,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg51.jpg",
      "zoom": null,
      "content": `

        <a href="https://www.olympics.com/athlete365/articles/milano-cortina2026/don-t-miss-these-services-in-your-village-at-milano-cortina-2026" target="_blank">
        <img class="abs halfScaleC halfpulse animatedpulse 51-btn" style="top:801px;left:78px;" src="/milanocortina2026/en/static/_content/51-btn-1.png"/>
      </a>
      
      `
      ,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": "Thank you to our Worldwide Olympic Partners  ALL WORLDWIDE OLYMPIC PARTNER SERVICES"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 51,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg52.jpg",
      "zoom": null,
      "content": `

      <div class="addContentLink" style="top:202px;left:236px;width:32px;height:40px">
        <a href="https://www.facebook.com/Athlete365/" target="_blank"></a>
      </div>
      <div class="addContentLink" style="top:202px;left:272px;width:32px;height:40px">
        <a href="https://www.linkedin.com/showcase/athlete365/" target="_blank"></a>
      </div>
      <div class="addContentLink" style="top:202px;left:310px;width:32px;height:40px">
        <a href="https://x.com/Athlete365" target="_blank"></a>
      </div>
      <div class="addContentLink" style="top:202px;left:344px;width:32px;height:40px">
        <a href="https://www.instagram.com/athlete365/" target="_blank"></a>
      </div>

      <div class="addContentLink" style="top:244px;left:230px;width:161px;height:19px">
        <a href="https://www.olympics.com/athlete365" target="_blank"></a>
      </div>`
      ,
      "script": `
        function onPageEnter() {
          setTimeout(function(){
            addContentLinks();
          }, 1000)
        }

        function onPageLeave() {
          removeContentLinks();
        }
      `,
      "searchText": "FOLLOW US olympics.com/athlete365"
    }]],
    "script": `
      function idOf(id) {
        return document.getElementById(id)
      }

      function cOf(klass) {
        return document.getElementsByClassName(klass)
      }

      function removeContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        contentLinks.map(function callback(e) {
          return e.className = 'addContentLink'
        })
      }

      function removeContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))

        contentLinks.map(function callback(e) {
          return e.className = 'addContentLink'
        })
        contentLinksThree.map(function callback(e) {
          return e.className = 'addContentLinkThree'
        })
      }

      function addContentLinks() {
        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))

        contentLinks.map(function callback(e) {
          return e.className = 'contentLink addContentLink'
        })
        contentLinksThree.map(function callback(e) {
          return e.className = 'contentLinkThree addContentLinkThree'
        })
      }

      function showOverlay(idx) {
        idOf(idx).className = 'contentOverlay visible'
      }

      function hideOverlay(idx) {
        idOf(idx).className = 'contentOverlay hidden noclick'
      }

      function animateNumber(element){
        if(element.getAttribute("data-number")){
          var args = JSON.parse(element.getAttribute("data-number"));
          var from = 0;
          var to = 100;
          var append = "";
          var preppend = "";
          var decimals = 0;
          var duration = 1;
          var ease = "Linear.easeNone";
          var comma = false;
          var separator = ",";
          var decChar = ".";
          for(obj in args){
            if(obj == "from") from = args[obj];
            if(obj == "to") to = args[obj];
            if(obj == "append") append = args[obj];
            if(obj == "preppend") preppend = args[obj];
            if(obj == "decimals") decimals = args[obj];
            if(obj == "duration") duration = args[obj];
            if(obj == "ease") ease = args[obj];
            if(obj == "comma") comma = args[obj];
            if(obj == "separator") separator = args[obj];
            if(obj == "decChar") decChar = args[obj];
          }
          var obj = {number: from}
          TweenMax.to(obj, duration, {number: to, onUpdate: function(){
            if(comma){
              console.log(obj.number)
              var str = obj.number.toFixed(decimals).toString();
              var predec = str.split(/^\d*/)[0];
              console.log("PREDEC", predec, typeof(predec));
              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')
              var comp = newstr.replace(/^,/, '')
              console.log("NEWSTR", newstr, typeof(newstr));
              // console.log({newstr})
              // var dp = str.split(/\.\d+/) ? str.split(/\.\d+/)[0] : "";
              // if(dp[0]) dp = dp[0].replace(".", decChar);
              var dp = "";
              element.innerHTML = preppend+comp+dp+append;
            }else{
              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(".", decChar)+append;
            }
          }, ease: eval(ease)});
        }else{
          return;
        }
      }

      function animateNumbers(klass, delay = 1, stagger = 0.3) {
        numbers = cOf(klass)

        setTimeout(function() {
          for (let i = 0; i < numbers.length; i++) {
            setTimeout(animateNumber, stagger * 1000 * i, numbers[i])
          }
        }, delay * 1000)
      }

      function resetNumbers(ele){
        var numbers = cOf(ele)
        for(var i=0; i<numbers.length; i++) {
          numbers[i].innerText= ""
        }
      }

      function individualGallery(index) {
        Publish.openGalleryTwo([['8-gal-1.jpg', '8-gal-2.jpg'], index])
      }
    `,
    "mobilePages": null,
    "mobileTemplate": null,
  }



// WEBPACK FOOTER //
// ./src/document.js